"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_data_service_1 = __importDefault(require("./base-data-service"));
const retrieval_params_1 = __importDefault(require("./../models/retrieval-params"));
const data_list_1 = __importDefault(require("./../models/data-list"));
const util_1 = require("./util");
const asset_1 = __importDefault(require("./../models/asset"));
const gateway_1 = __importDefault(require("./../models/gateway"));
const gatewaySoftwareVersion_1 = __importDefault(require("./../models/gatewaySoftwareVersion"));
const site_1 = __importDefault(require("./../models/site"));
const order_1 = __importDefault(require("./../models/order"));
const session_1 = __importDefault(require("./../models/session"));
const discount_1 = __importDefault(require("./../models/discount"));
const stripeSession_1 = __importDefault(require("./../models/stripeSession"));
const stripeWebhook_1 = __importDefault(require("./../models/stripeWebhook"));
const zapierWebhook_1 = __importDefault(require("./../models/zapierWebhook"));
const places_1 = __importDefault(require("./../models/places"));
const product_1 = __importDefault(require("./../models/product"));
const modbusModel_1 = __importDefault(require("./../models/modbusModel"));
const occupancySchedule_1 = __importDefault(require("./../models/occupancySchedule"));
const pubOrg_1 = __importDefault(require("./../models/pubOrg"));
const organisation_1 = __importDefault(require("./../models/organisation"));
const paymentCard_1 = __importDefault(require("./../models/paymentCard"));
const assetEvent_1 = __importDefault(require("./../models/assetEvent"));
const gatewayEvent_1 = __importDefault(require("./../models/gatewayEvent"));
const assetTelemetry_1 = __importDefault(require("./../models/assetTelemetry"));
const rule_1 = __importDefault(require("./../models/rule"));
const dataRequest_1 = __importDefault(require("./../models/dataRequest"));
const dataRequestLink_1 = __importDefault(require("./../models/dataRequestLink"));
const invoiceRequest_1 = __importDefault(require("./../models/invoiceRequest"));
const invoiceRequestLink_1 = __importDefault(require("./../models/invoiceRequestLink"));
const siteGroup_1 = __importDefault(require("./../models/siteGroup"));
const group_1 = __importDefault(require("./../models/group"));
const duckChargeAdmin_1 = __importDefault(require("./../models/duckChargeAdmin"));
const customFieldType_1 = __importDefault(require("./../models/customFieldType"));
const customField_1 = __importDefault(require("./../models/customField"));
const location_1 = __importDefault(require("./../models/location"));
const searchHistory_1 = __importDefault(require("./../models/searchHistory"));
const tariff_1 = __importDefault(require("./../models/tariff"));
const groupType_1 = __importDefault(require("./../models/groupType"));
const calculatorInbound_1 = __importDefault(require("./../models/calculatorInbound"));
const calculatorResult_1 = __importDefault(require("./../models/calculatorResult"));
const createReport_1 = __importDefault(require("./../models/createReport"));
const reportHistory_1 = __importDefault(require("./../models/reportHistory"));
const report_1 = __importDefault(require("./../models/report"));
const reportFile_1 = __importDefault(require("./../models/reportFile"));
const gaiaConversation_1 = __importDefault(require("./../models/gaiaConversation"));
const gaiaMessage_1 = __importDefault(require("./../models/gaiaMessage"));
const dataCategory_1 = __importDefault(require("./../models/dataCategory"));
const dataType_1 = __importDefault(require("./../models/dataType"));
const deviceCategory_1 = __importDefault(require("./../models/deviceCategory"));
const widgetBoard_1 = __importDefault(require("./../models/widgetBoard"));
const reportFileLink_1 = __importDefault(require("./../models/reportFileLink"));
const ruleEvent_1 = __importDefault(require("./../models/ruleEvent"));
const audit_1 = __importDefault(require("./../models/audit"));
const application_1 = __importDefault(require("./../models/application"));
const anomalyModel_1 = __importDefault(require("./../models/anomalyModel"));
const anomaly_1 = __importDefault(require("./../models/anomaly"));
const gridduckSubscription_1 = __importDefault(require("./../models/gridduckSubscription"));
const gridduckInvoice_1 = __importDefault(require("./../models/gridduckInvoice"));
const account_1 = __importDefault(require("./../models/account"));
const customFieldData_1 = __importDefault(require("./../models/customFieldData"));
const preferences_1 = __importDefault(require("./../models/preferences"));
const dcRetryPayment_1 = __importDefault(require("./../models/dcRetryPayment"));
const issue_1 = __importDefault(require("./../models/issue"));
const ignoredDevice_1 = __importDefault(require("./../models/ignoredDevice"));
const resetSecret_1 = __importDefault(require("./../models/resetSecret"));
const requestSecret_1 = __importDefault(require("./../models/requestSecret"));
const assetIdentification_1 = __importDefault(require("./../models/assetIdentification"));
const getPhaseBreakdown_1 = __importDefault(require("./../models/getPhaseBreakdown"));
const availableGateway_1 = __importDefault(require("./../models/availableGateway"));
const assetDemand_1 = __importDefault(require("./../models/assetDemand"));
const assetConsumption_1 = __importDefault(require("./../models/assetConsumption"));
const physicalGateway_1 = __importDefault(require("./../models/physicalGateway"));
const sitePermission_1 = __importDefault(require("./../models/sitePermission"));
const applianceCategory_1 = __importDefault(require("./../models/applianceCategory"));
const applianceType_1 = __importDefault(require("./../models/applianceType"));
const dataUpload_1 = __importDefault(require("./../models/dataUpload"));
const file_1 = __importDefault(require("./../models/file"));
const zip_1 = __importDefault(require("./../models/zip"));
const search_1 = __importDefault(require("./../models/search"));
const verifyOrgInvite_1 = __importDefault(require("./../models/verifyOrgInvite"));
const confirmOrgInvite_1 = __importDefault(require("./../models/confirmOrgInvite"));
const dcCreateAccount_1 = __importDefault(require("./../models/dcCreateAccount"));
const dcSession_1 = __importDefault(require("./../models/dcSession"));
const paymentSheet_1 = __importDefault(require("./../models/paymentSheet"));
const dcChargePoint_1 = __importDefault(require("./../models/dcChargePoint"));
const dcChargeStation_1 = __importDefault(require("./../models/dcChargeStation"));
const organisationInvite_1 = __importDefault(require("./../models/organisationInvite"));
const organisationMember_1 = __importDefault(require("./../models/organisationMember"));
const detectedDevice_1 = __importDefault(require("./../models/detectedDevice"));
const resetToken_1 = __importDefault(require("./../models/resetToken"));
const password_1 = __importDefault(require("./../models/password"));
const thirdPartyIntegration_1 = __importDefault(require("./../models/thirdPartyIntegration"));
const orgPartner_1 = __importDefault(require("./../models/orgPartner"));
const mfaSecret_1 = __importDefault(require("./../models/mfaSecret"));
const mfaVerification_1 = __importDefault(require("./../models/mfaVerification"));
const mfaAuthentication_1 = __importDefault(require("./../models/mfaAuthentication"));
const loginAs_1 = __importDefault(require("./../models/loginAs"));
const loginAsPartner_1 = __importDefault(require("./../models/loginAsPartner"));
const organisationManagement_1 = __importDefault(require("./../models/organisationManagement"));
const stagingDatabase_1 = __importDefault(require("./../models/stagingDatabase"));
const notification_1 = __importDefault(require("./../models/notification"));
const zigbeeFirmware_1 = __importDefault(require("./../models/zigbeeFirmware"));
const gatewayTrustList_1 = __importDefault(require("./../models/gatewayTrustList"));
const gatewayTrustedDeviceUntrustRequest_1 = __importDefault(require("./../models/gatewayTrustedDeviceUntrustRequest"));
const telemetryOperation_1 = __importDefault(require("./../models/telemetryOperation"));
const aggregateTelemetryGroupRequest_1 = __importDefault(require("./../models/aggregateTelemetryGroupRequest"));
const assetRemoveDataRequest_1 = __importDefault(require("./../models/assetRemoveDataRequest"));
const assetAggregateDataRequest_1 = __importDefault(require("./../models/assetAggregateDataRequest"));
const gatewayTrustedDeviceAnalysis_1 = __importDefault(require("./../models/gatewayTrustedDeviceAnalysis"));
const aggregateTelemetry_1 = __importDefault(require("./../models/aggregateTelemetry"));
const instantaneousTelemetry_1 = __importDefault(require("./../models/instantaneousTelemetry"));
const organisationSearch_1 = __importDefault(require("./../models/organisationSearch"));
const gatewayLogDownloadRequest_1 = __importDefault(require("./../models/gatewayLogDownloadRequest"));
const gatewayEnhancedLogDownloadRequest_1 = __importDefault(require("./../models/gatewayEnhancedLogDownloadRequest"));
const gatewayGod_1 = __importDefault(require("./../models/gatewayGod"));
const assetGod_1 = __importDefault(require("./../models/assetGod"));
const assetTelemetryBatch_1 = __importDefault(require("./../models/assetTelemetryBatch"));
const assetConsumptionBatch_1 = __importDefault(require("./../models/assetConsumptionBatch"));
const rawAggregateData_1 = __importDefault(require("./../models/rawAggregateData"));
const assetReset_1 = __importDefault(require("./../models/assetReset"));
const energyMasterTest_1 = __importDefault(require("./../models/energyMasterTest"));
const inspiredLogin_1 = __importDefault(require("./../models/inspiredLogin"));
const dataUnit_1 = __importDefault(require("./../models/dataUnit"));
const itemMetadata_1 = __importDefault(require("./../models/itemMetadata"));
class DataService extends base_data_service_1.default {
    getAssets(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'asset' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssets(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new asset_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assets, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'asset', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAsset(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.assets.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.assetGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAsset(paramsIn)
                .then(function (object) {
                return new asset_1.default(self, object);
            });
        }
        else {
            this.assetGetters[paramsIn.id] = this.apiService.getAsset(paramsIn)
                .then(function (object) {
                delete self.assetGetters[paramsIn.id];
                let newItem = new asset_1.default(self, object);
                newItem = self.mergeIntoList(self.assets, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.assetGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.assetGetters[paramsIn.id];
        }
    }
    createAsset(newItem) {
        let self = this;
        return this.apiService.createAsset(newItem).then(function (newObj) {
            let item = new asset_1.default(self, newObj);
            self.assets.push(item);
            return Promise.resolve(item);
        });
    }
    deleteAsset(itemId, item) {
        let self = this;
        return this.apiService.deleteAsset(itemId, item).then(function () {
            let existingModel = self.assets.find(m => m.id === itemId);
            if (existingModel) {
                self.assets.splice(self.assets.indexOf(existingModel), 1);
            }
        });
    }
    updateAsset(itemId, updateObj, item) {
        return this.apiService.updateAsset(itemId, updateObj, item);
    }
    getGateways(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gateway' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGateways(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gateway_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gateways, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gateway', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGateway(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gateways.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gatewayGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGateway(paramsIn)
                .then(function (object) {
                return new gateway_1.default(self, object);
            });
        }
        else {
            this.gatewayGetters[paramsIn.id] = this.apiService.getGateway(paramsIn)
                .then(function (object) {
                delete self.gatewayGetters[paramsIn.id];
                let newItem = new gateway_1.default(self, object);
                newItem = self.mergeIntoList(self.gateways, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gatewayGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gatewayGetters[paramsIn.id];
        }
    }
    createGateway(newItem) {
        let self = this;
        return this.apiService.createGateway(newItem).then(function (newObj) {
            let item = new gateway_1.default(self, newObj);
            self.gateways.push(item);
            return Promise.resolve(item);
        });
    }
    deleteGateway(itemId, item) {
        let self = this;
        return this.apiService.deleteGateway(itemId, item).then(function () {
            let existingModel = self.gateways.find(m => m.id === itemId);
            if (existingModel) {
                self.gateways.splice(self.gateways.indexOf(existingModel), 1);
            }
        });
    }
    updateGateway(itemId, updateObj, item) {
        return this.apiService.updateGateway(itemId, updateObj, item);
    }
    getGatewaySoftwareVersions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gatewaySoftwareVersion' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGatewaySoftwareVersions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gatewaySoftwareVersion_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gatewaySoftwareVersions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gatewaySoftwareVersion', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGatewaySoftwareVersion(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gatewaySoftwareVersions.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gatewaySoftwareVersionGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGatewaySoftwareVersion(paramsIn)
                .then(function (object) {
                return new gatewaySoftwareVersion_1.default(self, object);
            });
        }
        else {
            this.gatewaySoftwareVersionGetters[paramsIn.id] = this.apiService.getGatewaySoftwareVersion(paramsIn)
                .then(function (object) {
                delete self.gatewaySoftwareVersionGetters[paramsIn.id];
                let newItem = new gatewaySoftwareVersion_1.default(self, object);
                newItem = self.mergeIntoList(self.gatewaySoftwareVersions, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gatewaySoftwareVersionGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gatewaySoftwareVersionGetters[paramsIn.id];
        }
    }
    updateGatewaySoftwareVersion(itemId, updateObj, item) {
        return this.apiService.updateGatewaySoftwareVersion(itemId, updateObj, item);
    }
    getSites(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'site' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSites(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new site_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.sites, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'site', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getSite(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.sites.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.siteGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getSite(paramsIn)
                .then(function (object) {
                return new site_1.default(self, object);
            });
        }
        else {
            this.siteGetters[paramsIn.id] = this.apiService.getSite(paramsIn)
                .then(function (object) {
                delete self.siteGetters[paramsIn.id];
                let newItem = new site_1.default(self, object);
                newItem = self.mergeIntoList(self.sites, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.siteGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.siteGetters[paramsIn.id];
        }
    }
    createSite(newItem) {
        let self = this;
        return this.apiService.createSite(newItem).then(function (newObj) {
            let item = new site_1.default(self, newObj);
            self.sites.push(item);
            return Promise.resolve(item);
        });
    }
    deleteSite(itemId, item) {
        let self = this;
        return this.apiService.deleteSite(itemId, item).then(function () {
            let existingModel = self.sites.find(m => m.id === itemId);
            if (existingModel) {
                self.sites.splice(self.sites.indexOf(existingModel), 1);
            }
        });
    }
    updateSite(itemId, updateObj, item) {
        return this.apiService.updateSite(itemId, updateObj, item);
    }
    getOrders(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'order' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrders(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new order_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.orders, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'order', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createOrder(newItem) {
        let self = this;
        return this.apiService.createOrder(newItem).then(function (newObj) {
            let item = new order_1.default(self, newObj);
            self.orders.push(item);
            return Promise.resolve(item);
        });
    }
    getSessions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'session' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSessions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new session_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.sessions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'session', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getSession(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.sessions.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.sessionGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getSession(paramsIn)
                .then(function (object) {
                return new session_1.default(self, object);
            });
        }
        else {
            this.sessionGetters[paramsIn.id] = this.apiService.getSession(paramsIn)
                .then(function (object) {
                delete self.sessionGetters[paramsIn.id];
                let newItem = new session_1.default(self, object);
                newItem = self.mergeIntoList(self.sessions, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.sessionGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.sessionGetters[paramsIn.id];
        }
    }
    createSession(newItem) {
        let self = this;
        return this.apiService.createSession(newItem).then(function (newObj) {
            let item = new session_1.default(self, newObj);
            self.sessions.push(item);
            return Promise.resolve(item);
        });
    }
    deleteSession(itemId, item) {
        let self = this;
        return this.apiService.deleteSession(itemId, item).then(function () {
            let existingModel = self.sessions.find(m => m.id === itemId);
            if (existingModel) {
                self.sessions.splice(self.sessions.indexOf(existingModel), 1);
            }
        });
    }
    updateSession(itemId, updateObj, item) {
        return this.apiService.updateSession(itemId, updateObj, item);
    }
    getDiscounts(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'discount' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDiscounts(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new discount_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.discounts, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'discount', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createStripeSession(newItem) {
        let self = this;
        return this.apiService.createStripeSession(newItem).then(function (newObj) {
            let item = new stripeSession_1.default(self, newObj);
            self.stripeSessions.push(item);
            return Promise.resolve(item);
        });
    }
    createStripeWebhook(newItem) {
        let self = this;
        return this.apiService.createStripeWebhook(newItem).then(function (newObj) {
            let item = new stripeWebhook_1.default(self, newObj);
            self.stripeWebhooks.push(item);
            return Promise.resolve(item);
        });
    }
    createZapierWebhook(newItem) {
        let self = this;
        return this.apiService.createZapierWebhook(newItem).then(function (newObj) {
            let item = new zapierWebhook_1.default(self, newObj);
            self.zapierWebhooks.push(item);
            return Promise.resolve(item);
        });
    }
    getPlacess(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'places' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getPlacess(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new places_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.placess, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'places', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getPlaces(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.placess.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.placesGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getPlaces(paramsIn)
                .then(function (object) {
                return new places_1.default(self, object);
            });
        }
        else {
            this.placesGetters[paramsIn.id] = this.apiService.getPlaces(paramsIn)
                .then(function (object) {
                delete self.placesGetters[paramsIn.id];
                let newItem = new places_1.default(self, object);
                newItem = self.mergeIntoList(self.placess, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.placesGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.placesGetters[paramsIn.id];
        }
    }
    getProducts(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'product' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getProducts(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new product_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.products, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'product', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getModbusModels(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'modbusModel' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getModbusModels(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new modbusModel_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.modbusModels, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'modbusModel', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getModbusModel(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.modbusModels.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.modbusModelGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getModbusModel(paramsIn)
                .then(function (object) {
                return new modbusModel_1.default(self, object);
            });
        }
        else {
            this.modbusModelGetters[paramsIn.id] = this.apiService.getModbusModel(paramsIn)
                .then(function (object) {
                delete self.modbusModelGetters[paramsIn.id];
                let newItem = new modbusModel_1.default(self, object);
                newItem = self.mergeIntoList(self.modbusModels, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.modbusModelGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.modbusModelGetters[paramsIn.id];
        }
    }
    createModbusModel(newItem) {
        let self = this;
        return this.apiService.createModbusModel(newItem).then(function (newObj) {
            let item = new modbusModel_1.default(self, newObj);
            self.modbusModels.push(item);
            return Promise.resolve(item);
        });
    }
    deleteModbusModel(itemId, item) {
        let self = this;
        return this.apiService.deleteModbusModel(itemId, item).then(function () {
            let existingModel = self.modbusModels.find(m => m.id === itemId);
            if (existingModel) {
                self.modbusModels.splice(self.modbusModels.indexOf(existingModel), 1);
            }
        });
    }
    updateModbusModel(itemId, updateObj, item) {
        return this.apiService.updateModbusModel(itemId, updateObj, item);
    }
    getOccupancySchedules(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'occupancySchedule' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOccupancySchedules(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new occupancySchedule_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.occupancySchedules, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'occupancySchedule', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getOccupancySchedule(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.occupancySchedules.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.occupancyScheduleGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getOccupancySchedule(paramsIn)
                .then(function (object) {
                return new occupancySchedule_1.default(self, object);
            });
        }
        else {
            this.occupancyScheduleGetters[paramsIn.id] = this.apiService.getOccupancySchedule(paramsIn)
                .then(function (object) {
                delete self.occupancyScheduleGetters[paramsIn.id];
                let newItem = new occupancySchedule_1.default(self, object);
                newItem = self.mergeIntoList(self.occupancySchedules, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.occupancyScheduleGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.occupancyScheduleGetters[paramsIn.id];
        }
    }
    createOccupancySchedule(newItem) {
        let self = this;
        return this.apiService.createOccupancySchedule(newItem).then(function (newObj) {
            let item = new occupancySchedule_1.default(self, newObj);
            self.occupancySchedules.push(item);
            return Promise.resolve(item);
        });
    }
    deleteOccupancySchedule(itemId, item) {
        let self = this;
        return this.apiService.deleteOccupancySchedule(itemId, item).then(function () {
            let existingModel = self.occupancySchedules.find(m => m.id === itemId);
            if (existingModel) {
                self.occupancySchedules.splice(self.occupancySchedules.indexOf(existingModel), 1);
            }
        });
    }
    updateOccupancySchedule(itemId, updateObj, item) {
        return this.apiService.updateOccupancySchedule(itemId, updateObj, item);
    }
    createPubOrg(newItem) {
        let self = this;
        return this.apiService.createPubOrg(newItem).then(function (newObj) {
            let item = new pubOrg_1.default(self, newObj);
            self.pubOrgs.push(item);
            return Promise.resolve(item);
        });
    }
    getOrganisation(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.organisations.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.organisationGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getOrganisation(paramsIn)
                .then(function (object) {
                return new organisation_1.default(self, object);
            });
        }
        else {
            this.organisationGetters[paramsIn.id] = this.apiService.getOrganisation(paramsIn)
                .then(function (object) {
                delete self.organisationGetters[paramsIn.id];
                let newItem = new organisation_1.default(self, object);
                newItem = self.mergeIntoList(self.organisations, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.organisationGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.organisationGetters[paramsIn.id];
        }
    }
    updateOrganisation(itemId, updateObj, item) {
        return this.apiService.updateOrganisation(itemId, updateObj, item);
    }
    getPaymentCards(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'paymentCard' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getPaymentCards(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new paymentCard_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.paymentCards, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'paymentCard', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getPaymentCard(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.paymentCards.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.paymentCardGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getPaymentCard(paramsIn)
                .then(function (object) {
                return new paymentCard_1.default(self, object);
            });
        }
        else {
            this.paymentCardGetters[paramsIn.id] = this.apiService.getPaymentCard(paramsIn)
                .then(function (object) {
                delete self.paymentCardGetters[paramsIn.id];
                let newItem = new paymentCard_1.default(self, object);
                newItem = self.mergeIntoList(self.paymentCards, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.paymentCardGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.paymentCardGetters[paramsIn.id];
        }
    }
    createPaymentCard(newItem) {
        let self = this;
        return this.apiService.createPaymentCard(newItem).then(function (newObj) {
            let item = new paymentCard_1.default(self, newObj);
            self.paymentCards.push(item);
            return Promise.resolve(item);
        });
    }
    deletePaymentCard(itemId, item) {
        let self = this;
        return this.apiService.deletePaymentCard(itemId, item).then(function () {
            let existingModel = self.paymentCards.find(m => m.id === itemId);
            if (existingModel) {
                self.paymentCards.splice(self.paymentCards.indexOf(existingModel), 1);
            }
        });
    }
    updatePaymentCard(itemId, updateObj, item) {
        return this.apiService.updatePaymentCard(itemId, updateObj, item);
    }
    getAssetEvents(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetEvent' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetEvents(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetEvent_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetEvents, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetEvent', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGatewayEvents(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gatewayEvent' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGatewayEvents(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gatewayEvent_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gatewayEvents, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gatewayEvent', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAssetTelemetrys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetTelemetry' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetTelemetrys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetTelemetry_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetTelemetrys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetTelemetry', true);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getRules(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'rule' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getRules(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new rule_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.rules, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'rule', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getRule(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.rules.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.ruleGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getRule(paramsIn)
                .then(function (object) {
                return new rule_1.default(self, object);
            });
        }
        else {
            this.ruleGetters[paramsIn.id] = this.apiService.getRule(paramsIn)
                .then(function (object) {
                delete self.ruleGetters[paramsIn.id];
                let newItem = new rule_1.default(self, object);
                newItem = self.mergeIntoList(self.rules, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.ruleGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.ruleGetters[paramsIn.id];
        }
    }
    createRule(newItem) {
        let self = this;
        return this.apiService.createRule(newItem).then(function (newObj) {
            let item = new rule_1.default(self, newObj);
            self.rules.push(item);
            return Promise.resolve(item);
        });
    }
    deleteRule(itemId, item) {
        let self = this;
        return this.apiService.deleteRule(itemId, item).then(function () {
            let existingModel = self.rules.find(m => m.id === itemId);
            if (existingModel) {
                self.rules.splice(self.rules.indexOf(existingModel), 1);
            }
        });
    }
    updateRule(itemId, updateObj, item) {
        return this.apiService.updateRule(itemId, updateObj, item);
    }
    getDataRequests(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dataRequest' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDataRequests(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dataRequest_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dataRequests, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dataRequest', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataRequest(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dataRequests.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dataRequestGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDataRequest(paramsIn)
                .then(function (object) {
                return new dataRequest_1.default(self, object);
            });
        }
        else {
            this.dataRequestGetters[paramsIn.id] = this.apiService.getDataRequest(paramsIn)
                .then(function (object) {
                delete self.dataRequestGetters[paramsIn.id];
                let newItem = new dataRequest_1.default(self, object);
                newItem = self.mergeIntoList(self.dataRequests, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dataRequestGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dataRequestGetters[paramsIn.id];
        }
    }
    createDataRequest(newItem) {
        let self = this;
        return this.apiService.createDataRequest(newItem).then(function (newObj) {
            let item = new dataRequest_1.default(self, newObj);
            self.dataRequests.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDataRequest(itemId, item) {
        let self = this;
        return this.apiService.deleteDataRequest(itemId, item).then(function () {
            let existingModel = self.dataRequests.find(m => m.id === itemId);
            if (existingModel) {
                self.dataRequests.splice(self.dataRequests.indexOf(existingModel), 1);
            }
        });
    }
    createDataRequestLink(newItem) {
        let self = this;
        return this.apiService.createDataRequestLink(newItem).then(function (newObj) {
            let item = new dataRequestLink_1.default(self, newObj);
            self.dataRequestLinks.push(item);
            return Promise.resolve(item);
        });
    }
    getInvoiceRequests(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'invoiceRequest' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getInvoiceRequests(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new invoiceRequest_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.invoiceRequests, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'invoiceRequest', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getInvoiceRequest(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.invoiceRequests.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.invoiceRequestGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getInvoiceRequest(paramsIn)
                .then(function (object) {
                return new invoiceRequest_1.default(self, object);
            });
        }
        else {
            this.invoiceRequestGetters[paramsIn.id] = this.apiService.getInvoiceRequest(paramsIn)
                .then(function (object) {
                delete self.invoiceRequestGetters[paramsIn.id];
                let newItem = new invoiceRequest_1.default(self, object);
                newItem = self.mergeIntoList(self.invoiceRequests, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.invoiceRequestGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.invoiceRequestGetters[paramsIn.id];
        }
    }
    createInvoiceRequest(newItem) {
        let self = this;
        return this.apiService.createInvoiceRequest(newItem).then(function (newObj) {
            let item = new invoiceRequest_1.default(self, newObj);
            self.invoiceRequests.push(item);
            return Promise.resolve(item);
        });
    }
    deleteInvoiceRequest(itemId, item) {
        let self = this;
        return this.apiService.deleteInvoiceRequest(itemId, item).then(function () {
            let existingModel = self.invoiceRequests.find(m => m.id === itemId);
            if (existingModel) {
                self.invoiceRequests.splice(self.invoiceRequests.indexOf(existingModel), 1);
            }
        });
    }
    createInvoiceRequestLink(newItem) {
        let self = this;
        return this.apiService.createInvoiceRequestLink(newItem).then(function (newObj) {
            let item = new invoiceRequestLink_1.default(self, newObj);
            self.invoiceRequestLinks.push(item);
            return Promise.resolve(item);
        });
    }
    getSiteGroups(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'siteGroup' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSiteGroups(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new siteGroup_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.siteGroups, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'siteGroup', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getSiteGroup(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.siteGroups.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.siteGroupGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getSiteGroup(paramsIn)
                .then(function (object) {
                return new siteGroup_1.default(self, object);
            });
        }
        else {
            this.siteGroupGetters[paramsIn.id] = this.apiService.getSiteGroup(paramsIn)
                .then(function (object) {
                delete self.siteGroupGetters[paramsIn.id];
                let newItem = new siteGroup_1.default(self, object);
                newItem = self.mergeIntoList(self.siteGroups, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.siteGroupGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.siteGroupGetters[paramsIn.id];
        }
    }
    createSiteGroup(newItem) {
        let self = this;
        return this.apiService.createSiteGroup(newItem).then(function (newObj) {
            let item = new siteGroup_1.default(self, newObj);
            self.siteGroups.push(item);
            return Promise.resolve(item);
        });
    }
    deleteSiteGroup(itemId, item) {
        let self = this;
        return this.apiService.deleteSiteGroup(itemId, item).then(function () {
            let existingModel = self.siteGroups.find(m => m.id === itemId);
            if (existingModel) {
                self.siteGroups.splice(self.siteGroups.indexOf(existingModel), 1);
            }
        });
    }
    updateSiteGroup(itemId, updateObj, item) {
        return this.apiService.updateSiteGroup(itemId, updateObj, item);
    }
    getGroups(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'group' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGroups(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new group_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.groups, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'group', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGroup(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.groups.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.groupGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGroup(paramsIn)
                .then(function (object) {
                return new group_1.default(self, object);
            });
        }
        else {
            this.groupGetters[paramsIn.id] = this.apiService.getGroup(paramsIn)
                .then(function (object) {
                delete self.groupGetters[paramsIn.id];
                let newItem = new group_1.default(self, object);
                newItem = self.mergeIntoList(self.groups, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.groupGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.groupGetters[paramsIn.id];
        }
    }
    createGroup(newItem) {
        let self = this;
        return this.apiService.createGroup(newItem).then(function (newObj) {
            let item = new group_1.default(self, newObj);
            self.groups.push(item);
            return Promise.resolve(item);
        });
    }
    deleteGroup(itemId, item) {
        let self = this;
        return this.apiService.deleteGroup(itemId, item).then(function () {
            let existingModel = self.groups.find(m => m.id === itemId);
            if (existingModel) {
                self.groups.splice(self.groups.indexOf(existingModel), 1);
            }
        });
    }
    updateGroup(itemId, updateObj, item) {
        return this.apiService.updateGroup(itemId, updateObj, item);
    }
    getDuckChargeAdmins(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'duckChargeAdmin' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDuckChargeAdmins(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new duckChargeAdmin_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.duckChargeAdmins, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'duckChargeAdmin', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getCustomFieldTypes(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'customFieldType' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getCustomFieldTypes(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new customFieldType_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.customFieldTypes, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'customFieldType', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createCustomFieldType(newItem) {
        let self = this;
        return this.apiService.createCustomFieldType(newItem).then(function (newObj) {
            let item = new customFieldType_1.default(self, newObj);
            self.customFieldTypes.push(item);
            return Promise.resolve(item);
        });
    }
    deleteCustomFieldType(itemId, item) {
        let self = this;
        return this.apiService.deleteCustomFieldType(itemId, item).then(function () {
            let existingModel = self.customFieldTypes.find(m => m.id === itemId);
            if (existingModel) {
                self.customFieldTypes.splice(self.customFieldTypes.indexOf(existingModel), 1);
            }
        });
    }
    updateCustomFieldType(itemId, updateObj, item) {
        return this.apiService.updateCustomFieldType(itemId, updateObj, item);
    }
    getCustomFields(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'customField' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getCustomFields(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new customField_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.customFields, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'customField', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createCustomField(newItem) {
        let self = this;
        return this.apiService.createCustomField(newItem).then(function (newObj) {
            let item = new customField_1.default(self, newObj);
            self.customFields.push(item);
            return Promise.resolve(item);
        });
    }
    deleteCustomField(itemId, item) {
        let self = this;
        return this.apiService.deleteCustomField(itemId, item).then(function () {
            let existingModel = self.customFields.find(m => m.id === itemId);
            if (existingModel) {
                self.customFields.splice(self.customFields.indexOf(existingModel), 1);
            }
        });
    }
    updateCustomField(itemId, updateObj, item) {
        return this.apiService.updateCustomField(itemId, updateObj, item);
    }
    getLocations(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'location' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getLocations(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new location_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.locations, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'location', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createLocation(newItem) {
        let self = this;
        return this.apiService.createLocation(newItem).then(function (newObj) {
            let item = new location_1.default(self, newObj);
            self.locations.push(item);
            return Promise.resolve(item);
        });
    }
    deleteLocation(itemId, item) {
        let self = this;
        return this.apiService.deleteLocation(itemId, item).then(function () {
            let existingModel = self.locations.find(m => m.id === itemId);
            if (existingModel) {
                self.locations.splice(self.locations.indexOf(existingModel), 1);
            }
        });
    }
    updateLocation(itemId, updateObj, item) {
        return this.apiService.updateLocation(itemId, updateObj, item);
    }
    getSearchHistorys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'searchHistory' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSearchHistorys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new searchHistory_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.searchHistorys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'searchHistory', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createSearchHistory(newItem) {
        let self = this;
        return this.apiService.createSearchHistory(newItem).then(function (newObj) {
            let item = new searchHistory_1.default(self, newObj);
            self.searchHistorys.push(item);
            return Promise.resolve(item);
        });
    }
    deleteSearchHistory(itemId, item) {
        let self = this;
        return this.apiService.deleteSearchHistory(itemId, item).then(function () {
            let existingModel = self.searchHistorys.find(m => m.id === itemId);
            if (existingModel) {
                self.searchHistorys.splice(self.searchHistorys.indexOf(existingModel), 1);
            }
        });
    }
    getTariffs(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'tariff' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getTariffs(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new tariff_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.tariffs, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'tariff', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getTariff(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.tariffs.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.tariffGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getTariff(paramsIn)
                .then(function (object) {
                return new tariff_1.default(self, object);
            });
        }
        else {
            this.tariffGetters[paramsIn.id] = this.apiService.getTariff(paramsIn)
                .then(function (object) {
                delete self.tariffGetters[paramsIn.id];
                let newItem = new tariff_1.default(self, object);
                newItem = self.mergeIntoList(self.tariffs, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.tariffGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.tariffGetters[paramsIn.id];
        }
    }
    createTariff(newItem) {
        let self = this;
        return this.apiService.createTariff(newItem).then(function (newObj) {
            let item = new tariff_1.default(self, newObj);
            self.tariffs.push(item);
            return Promise.resolve(item);
        });
    }
    deleteTariff(itemId, item) {
        let self = this;
        return this.apiService.deleteTariff(itemId, item).then(function () {
            let existingModel = self.tariffs.find(m => m.id === itemId);
            if (existingModel) {
                self.tariffs.splice(self.tariffs.indexOf(existingModel), 1);
            }
        });
    }
    updateTariff(itemId, updateObj, item) {
        return this.apiService.updateTariff(itemId, updateObj, item);
    }
    getGroupTypes(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'groupType' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGroupTypes(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new groupType_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.groupTypes, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'groupType', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createGroupType(newItem) {
        let self = this;
        return this.apiService.createGroupType(newItem).then(function (newObj) {
            let item = new groupType_1.default(self, newObj);
            self.groupTypes.push(item);
            return Promise.resolve(item);
        });
    }
    deleteGroupType(itemId, item) {
        let self = this;
        return this.apiService.deleteGroupType(itemId, item).then(function () {
            let existingModel = self.groupTypes.find(m => m.id === itemId);
            if (existingModel) {
                self.groupTypes.splice(self.groupTypes.indexOf(existingModel), 1);
            }
        });
    }
    updateGroupType(itemId, updateObj, item) {
        return this.apiService.updateGroupType(itemId, updateObj, item);
    }
    createCalculatorInbound(newItem) {
        let self = this;
        return this.apiService.createCalculatorInbound(newItem).then(function (newObj) {
            let item = new calculatorInbound_1.default(self, newObj);
            self.calculatorInbounds.push(item);
            return Promise.resolve(item);
        });
    }
    createCalculatorResult(newItem) {
        let self = this;
        return this.apiService.createCalculatorResult(newItem).then(function (newObj) {
            let item = new calculatorResult_1.default(self, newObj);
            self.calculatorResults.push(item);
            return Promise.resolve(item);
        });
    }
    createCreateReport(newItem) {
        let self = this;
        return this.apiService.createCreateReport(newItem).then(function (newObj) {
            let item = new createReport_1.default(self, newObj);
            self.createReports.push(item);
            return Promise.resolve(item);
        });
    }
    getReportHistorys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'reportHistory' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getReportHistorys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new reportHistory_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.reportHistorys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'reportHistory', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getReports(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'report' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getReports(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new report_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.reports, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'report', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getReport(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.reports.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.reportGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getReport(paramsIn)
                .then(function (object) {
                return new report_1.default(self, object);
            });
        }
        else {
            this.reportGetters[paramsIn.id] = this.apiService.getReport(paramsIn)
                .then(function (object) {
                delete self.reportGetters[paramsIn.id];
                let newItem = new report_1.default(self, object);
                newItem = self.mergeIntoList(self.reports, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.reportGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.reportGetters[paramsIn.id];
        }
    }
    createReport(newItem) {
        let self = this;
        return this.apiService.createReport(newItem).then(function (newObj) {
            let item = new report_1.default(self, newObj);
            self.reports.push(item);
            return Promise.resolve(item);
        });
    }
    deleteReport(itemId, item) {
        let self = this;
        return this.apiService.deleteReport(itemId, item).then(function () {
            let existingModel = self.reports.find(m => m.id === itemId);
            if (existingModel) {
                self.reports.splice(self.reports.indexOf(existingModel), 1);
            }
        });
    }
    updateReport(itemId, updateObj, item) {
        return this.apiService.updateReport(itemId, updateObj, item);
    }
    getReportFiles(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'reportFile' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getReportFiles(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new reportFile_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.reportFiles, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'reportFile', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGaiaConversations(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gaiaConversation' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGaiaConversations(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gaiaConversation_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gaiaConversations, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gaiaConversation', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGaiaConversation(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gaiaConversations.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gaiaConversationGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGaiaConversation(paramsIn)
                .then(function (object) {
                return new gaiaConversation_1.default(self, object);
            });
        }
        else {
            this.gaiaConversationGetters[paramsIn.id] = this.apiService.getGaiaConversation(paramsIn)
                .then(function (object) {
                delete self.gaiaConversationGetters[paramsIn.id];
                let newItem = new gaiaConversation_1.default(self, object);
                newItem = self.mergeIntoList(self.gaiaConversations, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gaiaConversationGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gaiaConversationGetters[paramsIn.id];
        }
    }
    deleteGaiaConversation(itemId, item) {
        let self = this;
        return this.apiService.deleteGaiaConversation(itemId, item).then(function () {
            let existingModel = self.gaiaConversations.find(m => m.id === itemId);
            if (existingModel) {
                self.gaiaConversations.splice(self.gaiaConversations.indexOf(existingModel), 1);
            }
        });
    }
    updateGaiaConversation(itemId, updateObj, item) {
        return this.apiService.updateGaiaConversation(itemId, updateObj, item);
    }
    getGaiaMessages(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gaiaMessage' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGaiaMessages(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gaiaMessage_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gaiaMessages, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gaiaMessage', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createGaiaMessage(newItem) {
        let self = this;
        return this.apiService.createGaiaMessage(newItem).then(function (newObj) {
            let item = new gaiaMessage_1.default(self, newObj);
            self.gaiaMessages.push(item);
            return Promise.resolve(item);
        });
    }
    getDataCategorys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dataCategory' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDataCategorys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dataCategory_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dataCategorys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dataCategory', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataCategory(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dataCategorys.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dataCategoryGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDataCategory(paramsIn)
                .then(function (object) {
                return new dataCategory_1.default(self, object);
            });
        }
        else {
            this.dataCategoryGetters[paramsIn.id] = this.apiService.getDataCategory(paramsIn)
                .then(function (object) {
                delete self.dataCategoryGetters[paramsIn.id];
                let newItem = new dataCategory_1.default(self, object);
                newItem = self.mergeIntoList(self.dataCategorys, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dataCategoryGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dataCategoryGetters[paramsIn.id];
        }
    }
    createDataCategory(newItem) {
        let self = this;
        return this.apiService.createDataCategory(newItem).then(function (newObj) {
            let item = new dataCategory_1.default(self, newObj);
            self.dataCategorys.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDataCategory(itemId, item) {
        let self = this;
        return this.apiService.deleteDataCategory(itemId, item).then(function () {
            let existingModel = self.dataCategorys.find(m => m.id === itemId);
            if (existingModel) {
                self.dataCategorys.splice(self.dataCategorys.indexOf(existingModel), 1);
            }
        });
    }
    updateDataCategory(itemId, updateObj, item) {
        return this.apiService.updateDataCategory(itemId, updateObj, item);
    }
    getDataTypes(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dataType' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDataTypes(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dataType_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dataTypes, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dataType', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataType(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dataTypes.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dataTypeGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDataType(paramsIn)
                .then(function (object) {
                return new dataType_1.default(self, object);
            });
        }
        else {
            this.dataTypeGetters[paramsIn.id] = this.apiService.getDataType(paramsIn)
                .then(function (object) {
                delete self.dataTypeGetters[paramsIn.id];
                let newItem = new dataType_1.default(self, object);
                newItem = self.mergeIntoList(self.dataTypes, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dataTypeGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dataTypeGetters[paramsIn.id];
        }
    }
    createDataType(newItem) {
        let self = this;
        return this.apiService.createDataType(newItem).then(function (newObj) {
            let item = new dataType_1.default(self, newObj);
            self.dataTypes.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDataType(itemId, item) {
        let self = this;
        return this.apiService.deleteDataType(itemId, item).then(function () {
            let existingModel = self.dataTypes.find(m => m.id === itemId);
            if (existingModel) {
                self.dataTypes.splice(self.dataTypes.indexOf(existingModel), 1);
            }
        });
    }
    updateDataType(itemId, updateObj, item) {
        return this.apiService.updateDataType(itemId, updateObj, item);
    }
    getDeviceCategorys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'deviceCategory' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDeviceCategorys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new deviceCategory_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.deviceCategorys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'deviceCategory', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createDeviceCategory(newItem) {
        let self = this;
        return this.apiService.createDeviceCategory(newItem).then(function (newObj) {
            let item = new deviceCategory_1.default(self, newObj);
            self.deviceCategorys.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDeviceCategory(itemId, item) {
        let self = this;
        return this.apiService.deleteDeviceCategory(itemId, item).then(function () {
            let existingModel = self.deviceCategorys.find(m => m.id === itemId);
            if (existingModel) {
                self.deviceCategorys.splice(self.deviceCategorys.indexOf(existingModel), 1);
            }
        });
    }
    updateDeviceCategory(itemId, updateObj, item) {
        return this.apiService.updateDeviceCategory(itemId, updateObj, item);
    }
    getWidgetBoard(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.widgetBoards.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.widgetBoardGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getWidgetBoard(paramsIn)
                .then(function (object) {
                return new widgetBoard_1.default(self, object);
            });
        }
        else {
            this.widgetBoardGetters[paramsIn.id] = this.apiService.getWidgetBoard(paramsIn)
                .then(function (object) {
                delete self.widgetBoardGetters[paramsIn.id];
                let newItem = new widgetBoard_1.default(self, object);
                newItem = self.mergeIntoList(self.widgetBoards, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.widgetBoardGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.widgetBoardGetters[paramsIn.id];
        }
    }
    createWidgetBoard(newItem) {
        let self = this;
        return this.apiService.createWidgetBoard(newItem).then(function (newObj) {
            let item = new widgetBoard_1.default(self, newObj);
            self.widgetBoards.push(item);
            return Promise.resolve(item);
        });
    }
    updateWidgetBoard(itemId, updateObj, item) {
        return this.apiService.updateWidgetBoard(itemId, updateObj, item);
    }
    createReportFileLink(newItem) {
        let self = this;
        return this.apiService.createReportFileLink(newItem).then(function (newObj) {
            let item = new reportFileLink_1.default(self, newObj);
            self.reportFileLinks.push(item);
            return Promise.resolve(item);
        });
    }
    getRuleEvents(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'ruleEvent' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getRuleEvents(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new ruleEvent_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.ruleEvents, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'ruleEvent', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAudits(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'audit' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAudits(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new audit_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.audits, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'audit', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAudit(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.audits.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.auditGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAudit(paramsIn)
                .then(function (object) {
                return new audit_1.default(self, object);
            });
        }
        else {
            this.auditGetters[paramsIn.id] = this.apiService.getAudit(paramsIn)
                .then(function (object) {
                delete self.auditGetters[paramsIn.id];
                let newItem = new audit_1.default(self, object);
                newItem = self.mergeIntoList(self.audits, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.auditGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.auditGetters[paramsIn.id];
        }
    }
    createAudit(newItem) {
        let self = this;
        return this.apiService.createAudit(newItem).then(function (newObj) {
            let item = new audit_1.default(self, newObj);
            self.audits.push(item);
            return Promise.resolve(item);
        });
    }
    getApplications(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'application' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getApplications(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new application_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.applications, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'application', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getApplication(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.applications.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.applicationGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getApplication(paramsIn)
                .then(function (object) {
                return new application_1.default(self, object);
            });
        }
        else {
            this.applicationGetters[paramsIn.id] = this.apiService.getApplication(paramsIn)
                .then(function (object) {
                delete self.applicationGetters[paramsIn.id];
                let newItem = new application_1.default(self, object);
                newItem = self.mergeIntoList(self.applications, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.applicationGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.applicationGetters[paramsIn.id];
        }
    }
    createApplication(newItem) {
        let self = this;
        return this.apiService.createApplication(newItem).then(function (newObj) {
            let item = new application_1.default(self, newObj);
            self.applications.push(item);
            return Promise.resolve(item);
        });
    }
    deleteApplication(itemId, item) {
        let self = this;
        return this.apiService.deleteApplication(itemId, item).then(function () {
            let existingModel = self.applications.find(m => m.id === itemId);
            if (existingModel) {
                self.applications.splice(self.applications.indexOf(existingModel), 1);
            }
        });
    }
    getAnomalyModels(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'anomalyModel' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAnomalyModels(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new anomalyModel_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.anomalyModels, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'anomalyModel', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAnomalyModel(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.anomalyModels.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.anomalyModelGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAnomalyModel(paramsIn)
                .then(function (object) {
                return new anomalyModel_1.default(self, object);
            });
        }
        else {
            this.anomalyModelGetters[paramsIn.id] = this.apiService.getAnomalyModel(paramsIn)
                .then(function (object) {
                delete self.anomalyModelGetters[paramsIn.id];
                let newItem = new anomalyModel_1.default(self, object);
                newItem = self.mergeIntoList(self.anomalyModels, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.anomalyModelGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.anomalyModelGetters[paramsIn.id];
        }
    }
    getAnomalys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'anomaly' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAnomalys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new anomaly_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.anomalys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'anomaly', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAnomaly(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.anomalys.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.anomalyGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAnomaly(paramsIn)
                .then(function (object) {
                return new anomaly_1.default(self, object);
            });
        }
        else {
            this.anomalyGetters[paramsIn.id] = this.apiService.getAnomaly(paramsIn)
                .then(function (object) {
                delete self.anomalyGetters[paramsIn.id];
                let newItem = new anomaly_1.default(self, object);
                newItem = self.mergeIntoList(self.anomalys, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.anomalyGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.anomalyGetters[paramsIn.id];
        }
    }
    updateAnomaly(itemId, updateObj, item) {
        return this.apiService.updateAnomaly(itemId, updateObj, item);
    }
    getGridduckSubscriptions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gridduckSubscription' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGridduckSubscriptions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gridduckSubscription_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gridduckSubscriptions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gridduckSubscription', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGridduckInvoices(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gridduckInvoice' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGridduckInvoices(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gridduckInvoice_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gridduckInvoices, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gridduckInvoice', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAccounts(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'account' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAccounts(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new account_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.accounts, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'account', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAccount(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.accounts.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.accountGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAccount(paramsIn)
                .then(function (object) {
                return new account_1.default(self, object);
            });
        }
        else {
            this.accountGetters[paramsIn.id] = this.apiService.getAccount(paramsIn)
                .then(function (object) {
                delete self.accountGetters[paramsIn.id];
                let newItem = new account_1.default(self, object);
                newItem = self.mergeIntoList(self.accounts, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.accountGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.accountGetters[paramsIn.id];
        }
    }
    updateAccount(itemId, updateObj, item) {
        return this.apiService.updateAccount(itemId, updateObj, item);
    }
    getCustomFieldDatas(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'customFieldData' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getCustomFieldDatas(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new customFieldData_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.customFieldDatas, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'customFieldData', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getPreferences(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.preferencess.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.preferencesGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getPreferences(paramsIn)
                .then(function (object) {
                return new preferences_1.default(self, object);
            });
        }
        else {
            this.preferencesGetters[paramsIn.id] = this.apiService.getPreferences(paramsIn)
                .then(function (object) {
                delete self.preferencesGetters[paramsIn.id];
                let newItem = new preferences_1.default(self, object);
                newItem = self.mergeIntoList(self.preferencess, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.preferencesGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.preferencesGetters[paramsIn.id];
        }
    }
    updatePreferences(itemId, updateObj, item) {
        return this.apiService.updatePreferences(itemId, updateObj, item);
    }
    createDcRetryPayment(newItem) {
        let self = this;
        return this.apiService.createDcRetryPayment(newItem).then(function (newObj) {
            let item = new dcRetryPayment_1.default(self, newObj);
            self.dcRetryPayments.push(item);
            return Promise.resolve(item);
        });
    }
    getIssues(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'issue' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getIssues(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new issue_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.issues, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'issue', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getIgnoredDevices(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'ignoredDevice' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getIgnoredDevices(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new ignoredDevice_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.ignoredDevices, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'ignoredDevice', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createResetSecret(newItem) {
        let self = this;
        return this.apiService.createResetSecret(newItem).then(function (newObj) {
            let item = new resetSecret_1.default(self, newObj);
            self.resetSecrets.push(item);
            return Promise.resolve(item);
        });
    }
    createRequestSecret(newItem) {
        let self = this;
        return this.apiService.createRequestSecret(newItem).then(function (newObj) {
            let item = new requestSecret_1.default(self, newObj);
            self.requestSecrets.push(item);
            return Promise.resolve(item);
        });
    }
    createAssetIdentification(newItem) {
        let self = this;
        return this.apiService.createAssetIdentification(newItem).then(function (newObj) {
            let item = new assetIdentification_1.default(self, newObj);
            self.assetIdentifications.push(item);
            return Promise.resolve(item);
        });
    }
    createGetPhaseBreakdown(newItem) {
        let self = this;
        return this.apiService.createGetPhaseBreakdown(newItem).then(function (newObj) {
            let item = new getPhaseBreakdown_1.default(self, newObj);
            self.getPhaseBreakdowns.push(item);
            return Promise.resolve(item);
        });
    }
    getAvailableGateways(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'availableGateway' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAvailableGateways(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new availableGateway_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.availableGateways, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'availableGateway', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    updateAvailableGateway(itemId, updateObj, item) {
        return this.apiService.updateAvailableGateway(itemId, updateObj, item);
    }
    getAssetDemands(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetDemand' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetDemands(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetDemand_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetDemands, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetDemand', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAssetConsumptions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetConsumption' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetConsumptions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetConsumption_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetConsumptions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetConsumption', true);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getPhysicalGateway(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.physicalGateways.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.physicalGatewayGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getPhysicalGateway(paramsIn)
                .then(function (object) {
                return new physicalGateway_1.default(self, object);
            });
        }
        else {
            this.physicalGatewayGetters[paramsIn.id] = this.apiService.getPhysicalGateway(paramsIn)
                .then(function (object) {
                delete self.physicalGatewayGetters[paramsIn.id];
                let newItem = new physicalGateway_1.default(self, object);
                newItem = self.mergeIntoList(self.physicalGateways, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.physicalGatewayGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.physicalGatewayGetters[paramsIn.id];
        }
    }
    createPhysicalGateway(newItem) {
        let self = this;
        return this.apiService.createPhysicalGateway(newItem).then(function (newObj) {
            let item = new physicalGateway_1.default(self, newObj);
            self.physicalGateways.push(item);
            return Promise.resolve(item);
        });
    }
    updatePhysicalGateway(itemId, updateObj, item) {
        return this.apiService.updatePhysicalGateway(itemId, updateObj, item);
    }
    getSitePermissions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'sitePermission' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSitePermissions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new sitePermission_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.sitePermissions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'sitePermission', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createSitePermission(newItem) {
        let self = this;
        return this.apiService.createSitePermission(newItem).then(function (newObj) {
            let item = new sitePermission_1.default(self, newObj);
            self.sitePermissions.push(item);
            return Promise.resolve(item);
        });
    }
    deleteSitePermission(itemId, item) {
        let self = this;
        return this.apiService.deleteSitePermission(itemId, item).then(function () {
            let existingModel = self.sitePermissions.find(m => m.id === itemId);
            if (existingModel) {
                self.sitePermissions.splice(self.sitePermissions.indexOf(existingModel), 1);
            }
        });
    }
    updateSitePermission(itemId, updateObj, item) {
        return this.apiService.updateSitePermission(itemId, updateObj, item);
    }
    getApplianceCategorys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'applianceCategory' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getApplianceCategorys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new applianceCategory_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.applianceCategorys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'applianceCategory', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getApplianceTypes(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'applianceType' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getApplianceTypes(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new applianceType_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.applianceTypes, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'applianceType', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataUploads(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dataUpload' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDataUploads(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dataUpload_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dataUploads, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dataUpload', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataUpload(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dataUploads.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dataUploadGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDataUpload(paramsIn)
                .then(function (object) {
                return new dataUpload_1.default(self, object);
            });
        }
        else {
            this.dataUploadGetters[paramsIn.id] = this.apiService.getDataUpload(paramsIn)
                .then(function (object) {
                delete self.dataUploadGetters[paramsIn.id];
                let newItem = new dataUpload_1.default(self, object);
                newItem = self.mergeIntoList(self.dataUploads, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dataUploadGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dataUploadGetters[paramsIn.id];
        }
    }
    createDataUpload(newItem, onUploadProgress) {
        let self = this;
        return this.apiService.createDataUpload(newItem, onUploadProgress).then(function (newObj) {
            let item = new dataUpload_1.default(self, newObj);
            self.dataUploads.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDataUpload(itemId, item) {
        let self = this;
        return this.apiService.deleteDataUpload(itemId, item).then(function () {
            let existingModel = self.dataUploads.find(m => m.id === itemId);
            if (existingModel) {
                self.dataUploads.splice(self.dataUploads.indexOf(existingModel), 1);
            }
        });
    }
    updateDataUpload(itemId, updateObj, item) {
        return this.apiService.updateDataUpload(itemId, updateObj, item);
    }
    getFiles(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'file' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getFiles(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new file_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.files, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'file', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createFile(newItem, onUploadProgress) {
        let self = this;
        return this.apiService.createFile(newItem, onUploadProgress).then(function (newObj) {
            let item = new file_1.default(self, newObj);
            self.files.push(item);
            return Promise.resolve(item);
        });
    }
    deleteFile(itemId, item) {
        let self = this;
        return this.apiService.deleteFile(itemId, item).then(function () {
            let existingModel = self.files.find(m => m.id === itemId);
            if (existingModel) {
                self.files.splice(self.files.indexOf(existingModel), 1);
            }
        });
    }
    updateFile(itemId, updateObj, item) {
        return this.apiService.updateFile(itemId, updateObj, item);
    }
    createZip(newItem) {
        let self = this;
        return this.apiService.createZip(newItem).then(function (newObj) {
            let item = new zip_1.default(self, newObj);
            self.zips.push(item);
            return Promise.resolve(item);
        });
    }
    getSearchs(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'search' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getSearchs(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new search_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.searchs, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'search', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getVerifyOrgInvite(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.verifyOrgInvites.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.verifyOrgInviteGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getVerifyOrgInvite(paramsIn)
                .then(function (object) {
                return new verifyOrgInvite_1.default(self, object);
            });
        }
        else {
            this.verifyOrgInviteGetters[paramsIn.id] = this.apiService.getVerifyOrgInvite(paramsIn)
                .then(function (object) {
                delete self.verifyOrgInviteGetters[paramsIn.id];
                let newItem = new verifyOrgInvite_1.default(self, object);
                newItem = self.mergeIntoList(self.verifyOrgInvites, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.verifyOrgInviteGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.verifyOrgInviteGetters[paramsIn.id];
        }
    }
    createConfirmOrgInvite(newItem) {
        let self = this;
        return this.apiService.createConfirmOrgInvite(newItem).then(function (newObj) {
            let item = new confirmOrgInvite_1.default(self, newObj);
            self.confirmOrgInvites.push(item);
            return Promise.resolve(item);
        });
    }
    createDcCreateAccount(newItem) {
        let self = this;
        return this.apiService.createDcCreateAccount(newItem).then(function (newObj) {
            let item = new dcCreateAccount_1.default(self, newObj);
            self.dcCreateAccounts.push(item);
            return Promise.resolve(item);
        });
    }
    getDcSessions(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dcSession' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDcSessions(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dcSession_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dcSessions, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dcSession', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDcSession(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dcSessions.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dcSessionGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDcSession(paramsIn)
                .then(function (object) {
                return new dcSession_1.default(self, object);
            });
        }
        else {
            this.dcSessionGetters[paramsIn.id] = this.apiService.getDcSession(paramsIn)
                .then(function (object) {
                delete self.dcSessionGetters[paramsIn.id];
                let newItem = new dcSession_1.default(self, object);
                newItem = self.mergeIntoList(self.dcSessions, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dcSessionGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dcSessionGetters[paramsIn.id];
        }
    }
    createDcSession(newItem) {
        let self = this;
        return this.apiService.createDcSession(newItem).then(function (newObj) {
            let item = new dcSession_1.default(self, newObj);
            self.dcSessions.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDcSession(itemId, item) {
        let self = this;
        return this.apiService.deleteDcSession(itemId, item).then(function () {
            let existingModel = self.dcSessions.find(m => m.id === itemId);
            if (existingModel) {
                self.dcSessions.splice(self.dcSessions.indexOf(existingModel), 1);
            }
        });
    }
    createPaymentSheet(newItem) {
        let self = this;
        return this.apiService.createPaymentSheet(newItem).then(function (newObj) {
            let item = new paymentSheet_1.default(self, newObj);
            self.paymentSheets.push(item);
            return Promise.resolve(item);
        });
    }
    getDcChargePoint(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dcChargePoints.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dcChargePointGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDcChargePoint(paramsIn)
                .then(function (object) {
                return new dcChargePoint_1.default(self, object);
            });
        }
        else {
            this.dcChargePointGetters[paramsIn.id] = this.apiService.getDcChargePoint(paramsIn)
                .then(function (object) {
                delete self.dcChargePointGetters[paramsIn.id];
                let newItem = new dcChargePoint_1.default(self, object);
                newItem = self.mergeIntoList(self.dcChargePoints, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dcChargePointGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dcChargePointGetters[paramsIn.id];
        }
    }
    getDcChargeStations(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dcChargeStation' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDcChargeStations(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dcChargeStation_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dcChargeStations, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dcChargeStation', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getOrganisationInvites(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'organisationInvite' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrganisationInvites(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new organisationInvite_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.organisationInvites, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'organisationInvite', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createOrganisationInvite(newItem) {
        let self = this;
        return this.apiService.createOrganisationInvite(newItem).then(function (newObj) {
            let item = new organisationInvite_1.default(self, newObj);
            self.organisationInvites.push(item);
            return Promise.resolve(item);
        });
    }
    deleteOrganisationInvite(itemId, item) {
        let self = this;
        return this.apiService.deleteOrganisationInvite(itemId, item).then(function () {
            let existingModel = self.organisationInvites.find(m => m.id === itemId);
            if (existingModel) {
                self.organisationInvites.splice(self.organisationInvites.indexOf(existingModel), 1);
            }
        });
    }
    updateOrganisationInvite(itemId, updateObj, item) {
        return this.apiService.updateOrganisationInvite(itemId, updateObj, item);
    }
    getOrganisationMembers(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'organisationMember' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrganisationMembers(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new organisationMember_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.organisationMembers, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'organisationMember', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    deleteOrganisationMember(itemId, item) {
        let self = this;
        return this.apiService.deleteOrganisationMember(itemId, item).then(function () {
            let existingModel = self.organisationMembers.find(m => m.id === itemId);
            if (existingModel) {
                self.organisationMembers.splice(self.organisationMembers.indexOf(existingModel), 1);
            }
        });
    }
    updateOrganisationMember(itemId, updateObj, item) {
        return this.apiService.updateOrganisationMember(itemId, updateObj, item);
    }
    getDetectedDevices(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'detectedDevice' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDetectedDevices(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new detectedDevice_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.detectedDevices, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'detectedDevice', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    updateDetectedDevice(itemId, updateObj, item) {
        return this.apiService.updateDetectedDevice(itemId, updateObj, item);
    }
    getResetToken(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.resetTokens.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.resetTokenGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getResetToken(paramsIn)
                .then(function (object) {
                return new resetToken_1.default(self, object);
            });
        }
        else {
            this.resetTokenGetters[paramsIn.id] = this.apiService.getResetToken(paramsIn)
                .then(function (object) {
                delete self.resetTokenGetters[paramsIn.id];
                let newItem = new resetToken_1.default(self, object);
                newItem = self.mergeIntoList(self.resetTokens, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.resetTokenGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.resetTokenGetters[paramsIn.id];
        }
    }
    createResetToken(newItem) {
        let self = this;
        return this.apiService.createResetToken(newItem).then(function (newObj) {
            let item = new resetToken_1.default(self, newObj);
            self.resetTokens.push(item);
            return Promise.resolve(item);
        });
    }
    updateResetToken(itemId, updateObj, item) {
        return this.apiService.updateResetToken(itemId, updateObj, item);
    }
    createPassword(newItem) {
        let self = this;
        return this.apiService.createPassword(newItem).then(function (newObj) {
            let item = new password_1.default(self, newObj);
            self.passwords.push(item);
            return Promise.resolve(item);
        });
    }
    getThirdPartyIntegrations(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'thirdPartyIntegration' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getThirdPartyIntegrations(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new thirdPartyIntegration_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.thirdPartyIntegrations, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'thirdPartyIntegration', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createThirdPartyIntegration(newItem) {
        let self = this;
        return this.apiService.createThirdPartyIntegration(newItem).then(function (newObj) {
            let item = new thirdPartyIntegration_1.default(self, newObj);
            self.thirdPartyIntegrations.push(item);
            return Promise.resolve(item);
        });
    }
    getOrgPartners(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'orgPartner' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrgPartners(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new orgPartner_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.orgPartners, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'orgPartner', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getOrgPartner(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.orgPartners.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.orgPartnerGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getOrgPartner(paramsIn)
                .then(function (object) {
                return new orgPartner_1.default(self, object);
            });
        }
        else {
            this.orgPartnerGetters[paramsIn.id] = this.apiService.getOrgPartner(paramsIn)
                .then(function (object) {
                delete self.orgPartnerGetters[paramsIn.id];
                let newItem = new orgPartner_1.default(self, object);
                newItem = self.mergeIntoList(self.orgPartners, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.orgPartnerGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.orgPartnerGetters[paramsIn.id];
        }
    }
    createOrgPartner(newItem) {
        let self = this;
        return this.apiService.createOrgPartner(newItem).then(function (newObj) {
            let item = new orgPartner_1.default(self, newObj);
            self.orgPartners.push(item);
            return Promise.resolve(item);
        });
    }
    deleteOrgPartner(itemId, item) {
        let self = this;
        return this.apiService.deleteOrgPartner(itemId, item).then(function () {
            let existingModel = self.orgPartners.find(m => m.id === itemId);
            if (existingModel) {
                self.orgPartners.splice(self.orgPartners.indexOf(existingModel), 1);
            }
        });
    }
    updateOrgPartner(itemId, updateObj, item) {
        return this.apiService.updateOrgPartner(itemId, updateObj, item);
    }
    createMfaSecret(newItem) {
        let self = this;
        return this.apiService.createMfaSecret(newItem).then(function (newObj) {
            let item = new mfaSecret_1.default(self, newObj);
            self.mfaSecrets.push(item);
            return Promise.resolve(item);
        });
    }
    createMfaVerification(newItem) {
        let self = this;
        return this.apiService.createMfaVerification(newItem).then(function (newObj) {
            let item = new mfaVerification_1.default(self, newObj);
            self.mfaVerifications.push(item);
            return Promise.resolve(item);
        });
    }
    createMfaAuthentication(newItem) {
        let self = this;
        return this.apiService.createMfaAuthentication(newItem).then(function (newObj) {
            let item = new mfaAuthentication_1.default(self, newObj);
            self.mfaAuthentications.push(item);
            return Promise.resolve(item);
        });
    }
    createLoginAs(newItem) {
        let self = this;
        return this.apiService.createLoginAs(newItem).then(function (newObj) {
            let item = new loginAs_1.default(self, newObj);
            self.loginAss.push(item);
            return Promise.resolve(item);
        });
    }
    createLoginAsPartner(newItem) {
        let self = this;
        return this.apiService.createLoginAsPartner(newItem).then(function (newObj) {
            let item = new loginAsPartner_1.default(self, newObj);
            self.loginAsPartners.push(item);
            return Promise.resolve(item);
        });
    }
    getOrganisationManagements(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'organisationManagement' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrganisationManagements(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new organisationManagement_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.organisationManagements, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'organisationManagement', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getOrganisationManagement(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.organisationManagements.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.organisationManagementGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getOrganisationManagement(paramsIn)
                .then(function (object) {
                return new organisationManagement_1.default(self, object);
            });
        }
        else {
            this.organisationManagementGetters[paramsIn.id] = this.apiService.getOrganisationManagement(paramsIn)
                .then(function (object) {
                delete self.organisationManagementGetters[paramsIn.id];
                let newItem = new organisationManagement_1.default(self, object);
                newItem = self.mergeIntoList(self.organisationManagements, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.organisationManagementGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.organisationManagementGetters[paramsIn.id];
        }
    }
    updateOrganisationManagement(itemId, updateObj, item) {
        return this.apiService.updateOrganisationManagement(itemId, updateObj, item);
    }
    getStagingDatabase(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.stagingDatabases.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.stagingDatabaseGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getStagingDatabase(paramsIn)
                .then(function (object) {
                return new stagingDatabase_1.default(self, object);
            });
        }
        else {
            this.stagingDatabaseGetters[paramsIn.id] = this.apiService.getStagingDatabase(paramsIn)
                .then(function (object) {
                delete self.stagingDatabaseGetters[paramsIn.id];
                let newItem = new stagingDatabase_1.default(self, object);
                newItem = self.mergeIntoList(self.stagingDatabases, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.stagingDatabaseGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.stagingDatabaseGetters[paramsIn.id];
        }
    }
    updateStagingDatabase(itemId, updateObj, item) {
        return this.apiService.updateStagingDatabase(itemId, updateObj, item);
    }
    getNotifications(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'notification' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getNotifications(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new notification_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.notifications, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'notification', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    updateNotification(itemId, updateObj, item) {
        return this.apiService.updateNotification(itemId, updateObj, item);
    }
    getZigbeeFirmwares(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'zigbeeFirmware' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getZigbeeFirmwares(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new zigbeeFirmware_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.zigbeeFirmwares, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'zigbeeFirmware', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getZigbeeFirmware(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.zigbeeFirmwares.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.zigbeeFirmwareGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getZigbeeFirmware(paramsIn)
                .then(function (object) {
                return new zigbeeFirmware_1.default(self, object);
            });
        }
        else {
            this.zigbeeFirmwareGetters[paramsIn.id] = this.apiService.getZigbeeFirmware(paramsIn)
                .then(function (object) {
                delete self.zigbeeFirmwareGetters[paramsIn.id];
                let newItem = new zigbeeFirmware_1.default(self, object);
                newItem = self.mergeIntoList(self.zigbeeFirmwares, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.zigbeeFirmwareGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.zigbeeFirmwareGetters[paramsIn.id];
        }
    }
    getGatewayTrustList(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gatewayTrustLists.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gatewayTrustListGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGatewayTrustList(paramsIn)
                .then(function (object) {
                return new gatewayTrustList_1.default(self, object);
            });
        }
        else {
            this.gatewayTrustListGetters[paramsIn.id] = this.apiService.getGatewayTrustList(paramsIn)
                .then(function (object) {
                delete self.gatewayTrustListGetters[paramsIn.id];
                let newItem = new gatewayTrustList_1.default(self, object);
                newItem = self.mergeIntoList(self.gatewayTrustLists, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gatewayTrustListGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gatewayTrustListGetters[paramsIn.id];
        }
    }
    createGatewayTrustedDeviceUntrustRequest(newItem) {
        let self = this;
        return this.apiService.createGatewayTrustedDeviceUntrustRequest(newItem).then(function (newObj) {
            let item = new gatewayTrustedDeviceUntrustRequest_1.default(self, newObj);
            self.gatewayTrustedDeviceUntrustRequests.push(item);
            return Promise.resolve(item);
        });
    }
    getTelemetryOperations(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'telemetryOperation' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getTelemetryOperations(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new telemetryOperation_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.telemetryOperations, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'telemetryOperation', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createAggregateTelemetryGroupRequest(newItem) {
        let self = this;
        return this.apiService.createAggregateTelemetryGroupRequest(newItem).then(function (newObj) {
            let item = new aggregateTelemetryGroupRequest_1.default(self, newObj);
            self.aggregateTelemetryGroupRequests.push(item);
            return Promise.resolve(item);
        });
    }
    createAssetRemoveDataRequest(newItem) {
        let self = this;
        return this.apiService.createAssetRemoveDataRequest(newItem).then(function (newObj) {
            let item = new assetRemoveDataRequest_1.default(self, newObj);
            self.assetRemoveDataRequests.push(item);
            return Promise.resolve(item);
        });
    }
    createAssetAggregateDataRequest(newItem) {
        let self = this;
        return this.apiService.createAssetAggregateDataRequest(newItem).then(function (newObj) {
            let item = new assetAggregateDataRequest_1.default(self, newObj);
            self.assetAggregateDataRequests.push(item);
            return Promise.resolve(item);
        });
    }
    getGatewayTrustedDeviceAnalysiss(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gatewayTrustedDeviceAnalysis' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGatewayTrustedDeviceAnalysiss(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gatewayTrustedDeviceAnalysis_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gatewayTrustedDeviceAnalysiss, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gatewayTrustedDeviceAnalysis', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGatewayTrustedDeviceAnalysis(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gatewayTrustedDeviceAnalysiss.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGatewayTrustedDeviceAnalysis(paramsIn)
                .then(function (object) {
                return new gatewayTrustedDeviceAnalysis_1.default(self, object);
            });
        }
        else {
            this.gatewayTrustedDeviceAnalysisGetters[paramsIn.id] = this.apiService.getGatewayTrustedDeviceAnalysis(paramsIn)
                .then(function (object) {
                delete self.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
                let newItem = new gatewayTrustedDeviceAnalysis_1.default(self, object);
                newItem = self.mergeIntoList(self.gatewayTrustedDeviceAnalysiss, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gatewayTrustedDeviceAnalysisGetters[paramsIn.id];
        }
    }
    createGatewayTrustedDeviceAnalysis(newItem) {
        let self = this;
        return this.apiService.createGatewayTrustedDeviceAnalysis(newItem).then(function (newObj) {
            let item = new gatewayTrustedDeviceAnalysis_1.default(self, newObj);
            self.gatewayTrustedDeviceAnalysiss.push(item);
            return Promise.resolve(item);
        });
    }
    deleteGatewayTrustedDeviceAnalysis(itemId, item) {
        let self = this;
        return this.apiService.deleteGatewayTrustedDeviceAnalysis(itemId, item).then(function () {
            let existingModel = self.gatewayTrustedDeviceAnalysiss.find(m => m.id === itemId);
            if (existingModel) {
                self.gatewayTrustedDeviceAnalysiss.splice(self.gatewayTrustedDeviceAnalysiss.indexOf(existingModel), 1);
            }
        });
    }
    updateGatewayTrustedDeviceAnalysis(itemId, updateObj, item) {
        return this.apiService.updateGatewayTrustedDeviceAnalysis(itemId, updateObj, item);
    }
    getAggregateTelemetrys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'aggregateTelemetry' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAggregateTelemetrys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new aggregateTelemetry_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.aggregateTelemetrys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'aggregateTelemetry', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAggregateTelemetry(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.aggregateTelemetrys.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.aggregateTelemetryGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAggregateTelemetry(paramsIn)
                .then(function (object) {
                return new aggregateTelemetry_1.default(self, object);
            });
        }
        else {
            this.aggregateTelemetryGetters[paramsIn.id] = this.apiService.getAggregateTelemetry(paramsIn)
                .then(function (object) {
                delete self.aggregateTelemetryGetters[paramsIn.id];
                let newItem = new aggregateTelemetry_1.default(self, object);
                newItem = self.mergeIntoList(self.aggregateTelemetrys, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.aggregateTelemetryGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.aggregateTelemetryGetters[paramsIn.id];
        }
    }
    createAggregateTelemetry(newItem) {
        let self = this;
        return this.apiService.createAggregateTelemetry(newItem).then(function (newObj) {
            let item = new aggregateTelemetry_1.default(self, newObj);
            self.aggregateTelemetrys.push(item);
            return Promise.resolve(item);
        });
    }
    deleteAggregateTelemetry(itemId, item) {
        let self = this;
        return this.apiService.deleteAggregateTelemetry(itemId, item).then(function () {
            let existingModel = self.aggregateTelemetrys.find(m => m.id === itemId);
            if (existingModel) {
                self.aggregateTelemetrys.splice(self.aggregateTelemetrys.indexOf(existingModel), 1);
            }
        });
    }
    updateAggregateTelemetry(itemId, updateObj, item) {
        return this.apiService.updateAggregateTelemetry(itemId, updateObj, item);
    }
    getInstantaneousTelemetrys(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'instantaneousTelemetry' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getInstantaneousTelemetrys(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new instantaneousTelemetry_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.instantaneousTelemetrys, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'instantaneousTelemetry', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getInstantaneousTelemetry(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.instantaneousTelemetrys.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.instantaneousTelemetryGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getInstantaneousTelemetry(paramsIn)
                .then(function (object) {
                return new instantaneousTelemetry_1.default(self, object);
            });
        }
        else {
            this.instantaneousTelemetryGetters[paramsIn.id] = this.apiService.getInstantaneousTelemetry(paramsIn)
                .then(function (object) {
                delete self.instantaneousTelemetryGetters[paramsIn.id];
                let newItem = new instantaneousTelemetry_1.default(self, object);
                newItem = self.mergeIntoList(self.instantaneousTelemetrys, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.instantaneousTelemetryGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.instantaneousTelemetryGetters[paramsIn.id];
        }
    }
    createInstantaneousTelemetry(newItem) {
        let self = this;
        return this.apiService.createInstantaneousTelemetry(newItem).then(function (newObj) {
            let item = new instantaneousTelemetry_1.default(self, newObj);
            self.instantaneousTelemetrys.push(item);
            return Promise.resolve(item);
        });
    }
    deleteInstantaneousTelemetry(itemId, item) {
        let self = this;
        return this.apiService.deleteInstantaneousTelemetry(itemId, item).then(function () {
            let existingModel = self.instantaneousTelemetrys.find(m => m.id === itemId);
            if (existingModel) {
                self.instantaneousTelemetrys.splice(self.instantaneousTelemetrys.indexOf(existingModel), 1);
            }
        });
    }
    updateInstantaneousTelemetry(itemId, updateObj, item) {
        return this.apiService.updateInstantaneousTelemetry(itemId, updateObj, item);
    }
    getOrganisationSearchs(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'organisationSearch' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getOrganisationSearchs(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new organisationSearch_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.organisationSearchs, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'organisationSearch', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createGatewayLogDownloadRequest(newItem) {
        let self = this;
        return this.apiService.createGatewayLogDownloadRequest(newItem).then(function (newObj) {
            let item = new gatewayLogDownloadRequest_1.default(self, newObj);
            self.gatewayLogDownloadRequests.push(item);
            return Promise.resolve(item);
        });
    }
    createGatewayEnhancedLogDownloadRequest(newItem) {
        let self = this;
        return this.apiService.createGatewayEnhancedLogDownloadRequest(newItem).then(function (newObj) {
            let item = new gatewayEnhancedLogDownloadRequest_1.default(self, newObj);
            self.gatewayEnhancedLogDownloadRequests.push(item);
            return Promise.resolve(item);
        });
    }
    getGatewayGods(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'gatewayGod' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getGatewayGods(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new gatewayGod_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.gatewayGods, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'gatewayGod', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getGatewayGod(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.gatewayGods.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.gatewayGodGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getGatewayGod(paramsIn)
                .then(function (object) {
                return new gatewayGod_1.default(self, object);
            });
        }
        else {
            this.gatewayGodGetters[paramsIn.id] = this.apiService.getGatewayGod(paramsIn)
                .then(function (object) {
                delete self.gatewayGodGetters[paramsIn.id];
                let newItem = new gatewayGod_1.default(self, object);
                newItem = self.mergeIntoList(self.gatewayGods, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.gatewayGodGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.gatewayGodGetters[paramsIn.id];
        }
    }
    createGatewayGod(newItem) {
        let self = this;
        return this.apiService.createGatewayGod(newItem).then(function (newObj) {
            let item = new gatewayGod_1.default(self, newObj);
            self.gatewayGods.push(item);
            return Promise.resolve(item);
        });
    }
    deleteGatewayGod(itemId, item) {
        let self = this;
        return this.apiService.deleteGatewayGod(itemId, item).then(function () {
            let existingModel = self.gatewayGods.find(m => m.id === itemId);
            if (existingModel) {
                self.gatewayGods.splice(self.gatewayGods.indexOf(existingModel), 1);
            }
        });
    }
    updateGatewayGod(itemId, updateObj, item) {
        return this.apiService.updateGatewayGod(itemId, updateObj, item);
    }
    getAssetGods(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetGod' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetGods(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetGod_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetGods, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetGod', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAssetGod(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.assetGods.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.assetGodGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getAssetGod(paramsIn)
                .then(function (object) {
                return new assetGod_1.default(self, object);
            });
        }
        else {
            this.assetGodGetters[paramsIn.id] = this.apiService.getAssetGod(paramsIn)
                .then(function (object) {
                delete self.assetGodGetters[paramsIn.id];
                let newItem = new assetGod_1.default(self, object);
                newItem = self.mergeIntoList(self.assetGods, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.assetGodGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.assetGodGetters[paramsIn.id];
        }
    }
    createAssetGod(newItem) {
        let self = this;
        return this.apiService.createAssetGod(newItem).then(function (newObj) {
            let item = new assetGod_1.default(self, newObj);
            self.assetGods.push(item);
            return Promise.resolve(item);
        });
    }
    deleteAssetGod(itemId, item) {
        let self = this;
        return this.apiService.deleteAssetGod(itemId, item).then(function () {
            let existingModel = self.assetGods.find(m => m.id === itemId);
            if (existingModel) {
                self.assetGods.splice(self.assetGods.indexOf(existingModel), 1);
            }
        });
    }
    updateAssetGod(itemId, updateObj, item) {
        return this.apiService.updateAssetGod(itemId, updateObj, item);
    }
    getAssetTelemetryBatchs(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetTelemetryBatch' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetTelemetryBatchs(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetTelemetryBatch_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetTelemetryBatchs, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetTelemetryBatch', true);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAssetConsumptionBatchs(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetConsumptionBatch' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetConsumptionBatchs(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetConsumptionBatch_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetConsumptionBatchs, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetConsumptionBatch', true);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getRawAggregateDatas(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'rawAggregateData' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getRawAggregateDatas(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new rawAggregateData_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.rawAggregateDatas, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'rawAggregateData', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getAssetResets(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'assetReset' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getAssetResets(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new assetReset_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.assetResets, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'assetReset', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createAssetReset(newItem) {
        let self = this;
        return this.apiService.createAssetReset(newItem).then(function (newObj) {
            let item = new assetReset_1.default(self, newObj);
            self.assetResets.push(item);
            return Promise.resolve(item);
        });
    }
    deleteAssetReset(itemId, item) {
        let self = this;
        return this.apiService.deleteAssetReset(itemId, item).then(function () {
            let existingModel = self.assetResets.find(m => m.id === itemId);
            if (existingModel) {
                self.assetResets.splice(self.assetResets.indexOf(existingModel), 1);
            }
        });
    }
    updateAssetReset(itemId, updateObj, item) {
        return this.apiService.updateAssetReset(itemId, updateObj, item);
    }
    getEnergyMasterTests(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'energyMasterTest' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getEnergyMasterTests(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new energyMasterTest_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.energyMasterTests, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'energyMasterTest', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    createEnergyMasterTest(newItem) {
        let self = this;
        return this.apiService.createEnergyMasterTest(newItem).then(function (newObj) {
            let item = new energyMasterTest_1.default(self, newObj);
            self.energyMasterTests.push(item);
            return Promise.resolve(item);
        });
    }
    createInspiredLogin(newItem) {
        let self = this;
        return this.apiService.createInspiredLogin(newItem).then(function (newObj) {
            let item = new inspiredLogin_1.default(self, newObj);
            self.inspiredLogins.push(item);
            return Promise.resolve(item);
        });
    }
    getDataUnits(paramsIn) {
        let self = this;
        let params = new retrieval_params_1.default(paramsIn);
        let index = 'dataUnit' + JSON.stringify(params);
        let existingList = this.lists.filter(l => l.isListening === true).find(l => ((l.type + JSON.stringify(l.params)) === index));
        if (existingList) {
            return Promise.resolve(existingList);
        }
        let existingListPromise = this.listPromises[index];
        if (existingListPromise) {
            return existingListPromise;
        }
        this.listPromises[index] = this.apiService.getDataUnits(params)
            .then(function (results) {
            delete self.listPromises[index];
            let total = results.total;
            let dataListList = [];
            results.list.forEach(function (listObj) {
                let items = listObj.list.map(function (itemObj) {
                    let newItem = new dataUnit_1.default(self, itemObj);
                    newItem = self.mergeIntoList(self.dataUnits, newItem);
                    return newItem;
                });
                dataListList.push({
                    list: items,
                    id: listObj.id
                });
            });
            let list = new data_list_1.default(dataListList, total, params, self, 'dataUnit', undefined);
            self.lists.push(list);
            return list;
        })
            .catch(function (err) {
            delete self.listPromises[index];
            return Promise.reject(err);
        });
        return this.listPromises[index];
    }
    getDataUnit(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.dataUnits.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.dataUnitGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getDataUnit(paramsIn)
                .then(function (object) {
                return new dataUnit_1.default(self, object);
            });
        }
        else {
            this.dataUnitGetters[paramsIn.id] = this.apiService.getDataUnit(paramsIn)
                .then(function (object) {
                delete self.dataUnitGetters[paramsIn.id];
                let newItem = new dataUnit_1.default(self, object);
                newItem = self.mergeIntoList(self.dataUnits, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.dataUnitGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.dataUnitGetters[paramsIn.id];
        }
    }
    createDataUnit(newItem) {
        let self = this;
        return this.apiService.createDataUnit(newItem).then(function (newObj) {
            let item = new dataUnit_1.default(self, newObj);
            self.dataUnits.push(item);
            return Promise.resolve(item);
        });
    }
    deleteDataUnit(itemId, item) {
        let self = this;
        return this.apiService.deleteDataUnit(itemId, item).then(function () {
            let existingModel = self.dataUnits.find(m => m.id === itemId);
            if (existingModel) {
                self.dataUnits.splice(self.dataUnits.indexOf(existingModel), 1);
            }
        });
    }
    updateDataUnit(itemId, updateObj, item) {
        return this.apiService.updateDataUnit(itemId, updateObj, item);
    }
    getItemMetadata(paramsIn) {
        let self = this;
        let presentObject = paramsIn.noCache ? undefined : self.itemMetadatas.find(o => (o.id === paramsIn.id || paramsIn.id === '') && o.isListening);
        if (presentObject) {
            return Promise.resolve(presentObject);
        }
        let presentObjectPromise = paramsIn.noCache ? undefined : self.itemMetadataGetters[paramsIn.id];
        if (presentObjectPromise) {
            return presentObjectPromise;
        }
        if (paramsIn.noCache) {
            return this.apiService.getItemMetadata(paramsIn)
                .then(function (object) {
                return new itemMetadata_1.default(self, object);
            });
        }
        else {
            this.itemMetadataGetters[paramsIn.id] = this.apiService.getItemMetadata(paramsIn)
                .then(function (object) {
                delete self.itemMetadataGetters[paramsIn.id];
                let newItem = new itemMetadata_1.default(self, object);
                newItem = self.mergeIntoList(self.itemMetadatas, newItem);
                return newItem;
            })
                .catch(function (err) {
                delete self.itemMetadataGetters[paramsIn.id];
                return Promise.reject(err);
            });
            return this.itemMetadataGetters[paramsIn.id];
        }
    }
    clearLists() {
        this.lists = [];
        this.listPromises = {};
        this.assetGetters = {};
        this.assets = [];
        this.gatewayGetters = {};
        this.gateways = [];
        this.gatewaySoftwareVersionGetters = {};
        this.gatewaySoftwareVersions = [];
        this.siteGetters = {};
        this.sites = [];
        this.orderGetters = {};
        this.orders = [];
        this.sessionGetters = {};
        this.sessions = [];
        this.discountGetters = {};
        this.discounts = [];
        this.stripeSessionGetters = {};
        this.stripeSessions = [];
        this.stripeWebhookGetters = {};
        this.stripeWebhooks = [];
        this.zapierWebhookGetters = {};
        this.zapierWebhooks = [];
        this.placesGetters = {};
        this.placess = [];
        this.productGetters = {};
        this.products = [];
        this.modbusModelGetters = {};
        this.modbusModels = [];
        this.occupancyScheduleGetters = {};
        this.occupancySchedules = [];
        this.pubOrgGetters = {};
        this.pubOrgs = [];
        this.organisationGetters = {};
        this.organisations = [];
        this.paymentCardGetters = {};
        this.paymentCards = [];
        this.assetEventGetters = {};
        this.assetEvents = [];
        this.gatewayEventGetters = {};
        this.gatewayEvents = [];
        this.assetTelemetryGetters = {};
        this.assetTelemetrys = [];
        this.ruleGetters = {};
        this.rules = [];
        this.dataRequestGetters = {};
        this.dataRequests = [];
        this.dataRequestLinkGetters = {};
        this.dataRequestLinks = [];
        this.invoiceRequestGetters = {};
        this.invoiceRequests = [];
        this.invoiceRequestLinkGetters = {};
        this.invoiceRequestLinks = [];
        this.siteGroupGetters = {};
        this.siteGroups = [];
        this.groupGetters = {};
        this.groups = [];
        this.duckChargeAdminGetters = {};
        this.duckChargeAdmins = [];
        this.customFieldTypeGetters = {};
        this.customFieldTypes = [];
        this.customFieldGetters = {};
        this.customFields = [];
        this.locationGetters = {};
        this.locations = [];
        this.searchHistoryGetters = {};
        this.searchHistorys = [];
        this.tariffGetters = {};
        this.tariffs = [];
        this.groupTypeGetters = {};
        this.groupTypes = [];
        this.calculatorInboundGetters = {};
        this.calculatorInbounds = [];
        this.calculatorResultGetters = {};
        this.calculatorResults = [];
        this.createReportGetters = {};
        this.createReports = [];
        this.reportHistoryGetters = {};
        this.reportHistorys = [];
        this.reportGetters = {};
        this.reports = [];
        this.reportFileGetters = {};
        this.reportFiles = [];
        this.gaiaConversationGetters = {};
        this.gaiaConversations = [];
        this.gaiaMessageGetters = {};
        this.gaiaMessages = [];
        this.dataCategoryGetters = {};
        this.dataCategorys = [];
        this.dataTypeGetters = {};
        this.dataTypes = [];
        this.deviceCategoryGetters = {};
        this.deviceCategorys = [];
        this.widgetBoardGetters = {};
        this.widgetBoards = [];
        this.reportFileLinkGetters = {};
        this.reportFileLinks = [];
        this.ruleEventGetters = {};
        this.ruleEvents = [];
        this.auditGetters = {};
        this.audits = [];
        this.applicationGetters = {};
        this.applications = [];
        this.anomalyModelGetters = {};
        this.anomalyModels = [];
        this.anomalyGetters = {};
        this.anomalys = [];
        this.gridduckSubscriptionGetters = {};
        this.gridduckSubscriptions = [];
        this.gridduckInvoiceGetters = {};
        this.gridduckInvoices = [];
        this.accountGetters = {};
        this.accounts = [];
        this.customFieldDataGetters = {};
        this.customFieldDatas = [];
        this.preferencesGetters = {};
        this.preferencess = [];
        this.dcRetryPaymentGetters = {};
        this.dcRetryPayments = [];
        this.issueGetters = {};
        this.issues = [];
        this.ignoredDeviceGetters = {};
        this.ignoredDevices = [];
        this.resetSecretGetters = {};
        this.resetSecrets = [];
        this.requestSecretGetters = {};
        this.requestSecrets = [];
        this.assetIdentificationGetters = {};
        this.assetIdentifications = [];
        this.getPhaseBreakdownGetters = {};
        this.getPhaseBreakdowns = [];
        this.availableGatewayGetters = {};
        this.availableGateways = [];
        this.assetDemandGetters = {};
        this.assetDemands = [];
        this.assetConsumptionGetters = {};
        this.assetConsumptions = [];
        this.physicalGatewayGetters = {};
        this.physicalGateways = [];
        this.sitePermissionGetters = {};
        this.sitePermissions = [];
        this.applianceCategoryGetters = {};
        this.applianceCategorys = [];
        this.applianceTypeGetters = {};
        this.applianceTypes = [];
        this.dataUploadGetters = {};
        this.dataUploads = [];
        this.fileGetters = {};
        this.files = [];
        this.zipGetters = {};
        this.zips = [];
        this.searchGetters = {};
        this.searchs = [];
        this.verifyOrgInviteGetters = {};
        this.verifyOrgInvites = [];
        this.confirmOrgInviteGetters = {};
        this.confirmOrgInvites = [];
        this.dcCreateAccountGetters = {};
        this.dcCreateAccounts = [];
        this.dcSessionGetters = {};
        this.dcSessions = [];
        this.paymentSheetGetters = {};
        this.paymentSheets = [];
        this.dcChargePointGetters = {};
        this.dcChargePoints = [];
        this.dcChargeStationGetters = {};
        this.dcChargeStations = [];
        this.organisationInviteGetters = {};
        this.organisationInvites = [];
        this.organisationMemberGetters = {};
        this.organisationMembers = [];
        this.detectedDeviceGetters = {};
        this.detectedDevices = [];
        this.resetTokenGetters = {};
        this.resetTokens = [];
        this.passwordGetters = {};
        this.passwords = [];
        this.thirdPartyIntegrationGetters = {};
        this.thirdPartyIntegrations = [];
        this.orgPartnerGetters = {};
        this.orgPartners = [];
        this.mfaSecretGetters = {};
        this.mfaSecrets = [];
        this.mfaVerificationGetters = {};
        this.mfaVerifications = [];
        this.mfaAuthenticationGetters = {};
        this.mfaAuthentications = [];
        this.loginAsGetters = {};
        this.loginAss = [];
        this.loginAsPartnerGetters = {};
        this.loginAsPartners = [];
        this.organisationManagementGetters = {};
        this.organisationManagements = [];
        this.stagingDatabaseGetters = {};
        this.stagingDatabases = [];
        this.notificationGetters = {};
        this.notifications = [];
        this.zigbeeFirmwareGetters = {};
        this.zigbeeFirmwares = [];
        this.gatewayTrustListGetters = {};
        this.gatewayTrustLists = [];
        this.gatewayTrustedDeviceUntrustRequestGetters = {};
        this.gatewayTrustedDeviceUntrustRequests = [];
        this.telemetryOperationGetters = {};
        this.telemetryOperations = [];
        this.aggregateTelemetryGroupRequestGetters = {};
        this.aggregateTelemetryGroupRequests = [];
        this.assetRemoveDataRequestGetters = {};
        this.assetRemoveDataRequests = [];
        this.assetAggregateDataRequestGetters = {};
        this.assetAggregateDataRequests = [];
        this.gatewayTrustedDeviceAnalysisGetters = {};
        this.gatewayTrustedDeviceAnalysiss = [];
        this.aggregateTelemetryGetters = {};
        this.aggregateTelemetrys = [];
        this.instantaneousTelemetryGetters = {};
        this.instantaneousTelemetrys = [];
        this.organisationSearchGetters = {};
        this.organisationSearchs = [];
        this.gatewayLogDownloadRequestGetters = {};
        this.gatewayLogDownloadRequests = [];
        this.gatewayEnhancedLogDownloadRequestGetters = {};
        this.gatewayEnhancedLogDownloadRequests = [];
        this.gatewayGodGetters = {};
        this.gatewayGods = [];
        this.assetGodGetters = {};
        this.assetGods = [];
        this.assetTelemetryBatchGetters = {};
        this.assetTelemetryBatchs = [];
        this.assetConsumptionBatchGetters = {};
        this.assetConsumptionBatchs = [];
        this.rawAggregateDataGetters = {};
        this.rawAggregateDatas = [];
        this.assetResetGetters = {};
        this.assetResets = [];
        this.energyMasterTestGetters = {};
        this.energyMasterTests = [];
        this.inspiredLoginGetters = {};
        this.inspiredLogins = [];
        this.dataUnitGetters = {};
        this.dataUnits = [];
        this.itemMetadataGetters = {};
        this.itemMetadatas = [];
    }
    resync() {
        let self = this;
        this.sendResubRequest();
        let visibleAssets = this.assets.filter(i => i.isListening === true);
        visibleAssets.forEach(function (visibleAsset) {
            return __awaiter(this, void 0, void 0, function* () {
                let assetData = yield self.apiService.getAsset({ id: visibleAsset.id });
                Object.keys(visibleAsset).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAsset[fixedKey] !== assetData[(0, util_1.toSnake)(fixedKey)] && assetData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAsset.inSet(fixedKey, assetData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGateways = this.gateways.filter(i => i.isListening === true);
        visibleGateways.forEach(function (visibleGateway) {
            return __awaiter(this, void 0, void 0, function* () {
                let gatewayData = yield self.apiService.getGateway({ id: visibleGateway.id });
                Object.keys(visibleGateway).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGateway[fixedKey] !== gatewayData[(0, util_1.toSnake)(fixedKey)] && gatewayData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGateway.inSet(fixedKey, gatewayData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGatewaySoftwareVersions = this.gatewaySoftwareVersions.filter(i => i.isListening === true);
        visibleGatewaySoftwareVersions.forEach(function (visibleGatewaySoftwareVersion) {
            return __awaiter(this, void 0, void 0, function* () {
                let gatewaySoftwareVersionData = yield self.apiService.getGatewaySoftwareVersion({ id: visibleGatewaySoftwareVersion.id });
                Object.keys(visibleGatewaySoftwareVersion).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGatewaySoftwareVersion[fixedKey] !== gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)] && gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGatewaySoftwareVersion.inSet(fixedKey, gatewaySoftwareVersionData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleSites = this.sites.filter(i => i.isListening === true);
        visibleSites.forEach(function (visibleSite) {
            return __awaiter(this, void 0, void 0, function* () {
                let siteData = yield self.apiService.getSite({ id: visibleSite.id });
                Object.keys(visibleSite).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleSite[fixedKey] !== siteData[(0, util_1.toSnake)(fixedKey)] && siteData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleSite.inSet(fixedKey, siteData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleSessions = this.sessions.filter(i => i.isListening === true);
        visibleSessions.forEach(function (visibleSession) {
            return __awaiter(this, void 0, void 0, function* () {
                let sessionData = yield self.apiService.getSession({ id: visibleSession.id });
                Object.keys(visibleSession).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleSession[fixedKey] !== sessionData[(0, util_1.toSnake)(fixedKey)] && sessionData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleSession.inSet(fixedKey, sessionData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visiblePlacess = this.placess.filter(i => i.isListening === true);
        visiblePlacess.forEach(function (visiblePlaces) {
            return __awaiter(this, void 0, void 0, function* () {
                let placesData = yield self.apiService.getPlaces({ id: visiblePlaces.id });
                Object.keys(visiblePlaces).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visiblePlaces[fixedKey] !== placesData[(0, util_1.toSnake)(fixedKey)] && placesData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visiblePlaces.inSet(fixedKey, placesData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleModbusModels = this.modbusModels.filter(i => i.isListening === true);
        visibleModbusModels.forEach(function (visibleModbusModel) {
            return __awaiter(this, void 0, void 0, function* () {
                let modbusModelData = yield self.apiService.getModbusModel({ id: visibleModbusModel.id });
                Object.keys(visibleModbusModel).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleModbusModel[fixedKey] !== modbusModelData[(0, util_1.toSnake)(fixedKey)] && modbusModelData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleModbusModel.inSet(fixedKey, modbusModelData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleOccupancySchedules = this.occupancySchedules.filter(i => i.isListening === true);
        visibleOccupancySchedules.forEach(function (visibleOccupancySchedule) {
            return __awaiter(this, void 0, void 0, function* () {
                let occupancyScheduleData = yield self.apiService.getOccupancySchedule({ id: visibleOccupancySchedule.id });
                Object.keys(visibleOccupancySchedule).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleOccupancySchedule[fixedKey] !== occupancyScheduleData[(0, util_1.toSnake)(fixedKey)] && occupancyScheduleData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleOccupancySchedule.inSet(fixedKey, occupancyScheduleData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleOrganisations = this.organisations.filter(i => i.isListening === true);
        visibleOrganisations.forEach(function (visibleOrganisation) {
            return __awaiter(this, void 0, void 0, function* () {
                let organisationData = yield self.apiService.getOrganisation({ id: visibleOrganisation.id });
                Object.keys(visibleOrganisation).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleOrganisation[fixedKey] !== organisationData[(0, util_1.toSnake)(fixedKey)] && organisationData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleOrganisation.inSet(fixedKey, organisationData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visiblePaymentCards = this.paymentCards.filter(i => i.isListening === true);
        visiblePaymentCards.forEach(function (visiblePaymentCard) {
            return __awaiter(this, void 0, void 0, function* () {
                let paymentCardData = yield self.apiService.getPaymentCard({ id: visiblePaymentCard.id });
                Object.keys(visiblePaymentCard).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visiblePaymentCard[fixedKey] !== paymentCardData[(0, util_1.toSnake)(fixedKey)] && paymentCardData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visiblePaymentCard.inSet(fixedKey, paymentCardData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleRules = this.rules.filter(i => i.isListening === true);
        visibleRules.forEach(function (visibleRule) {
            return __awaiter(this, void 0, void 0, function* () {
                let ruleData = yield self.apiService.getRule({ id: visibleRule.id });
                Object.keys(visibleRule).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleRule[fixedKey] !== ruleData[(0, util_1.toSnake)(fixedKey)] && ruleData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleRule.inSet(fixedKey, ruleData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDataRequests = this.dataRequests.filter(i => i.isListening === true);
        visibleDataRequests.forEach(function (visibleDataRequest) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataRequestData = yield self.apiService.getDataRequest({ id: visibleDataRequest.id });
                Object.keys(visibleDataRequest).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDataRequest[fixedKey] !== dataRequestData[(0, util_1.toSnake)(fixedKey)] && dataRequestData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDataRequest.inSet(fixedKey, dataRequestData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleInvoiceRequests = this.invoiceRequests.filter(i => i.isListening === true);
        visibleInvoiceRequests.forEach(function (visibleInvoiceRequest) {
            return __awaiter(this, void 0, void 0, function* () {
                let invoiceRequestData = yield self.apiService.getInvoiceRequest({ id: visibleInvoiceRequest.id });
                Object.keys(visibleInvoiceRequest).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleInvoiceRequest[fixedKey] !== invoiceRequestData[(0, util_1.toSnake)(fixedKey)] && invoiceRequestData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleInvoiceRequest.inSet(fixedKey, invoiceRequestData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleSiteGroups = this.siteGroups.filter(i => i.isListening === true);
        visibleSiteGroups.forEach(function (visibleSiteGroup) {
            return __awaiter(this, void 0, void 0, function* () {
                let siteGroupData = yield self.apiService.getSiteGroup({ id: visibleSiteGroup.id });
                Object.keys(visibleSiteGroup).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleSiteGroup[fixedKey] !== siteGroupData[(0, util_1.toSnake)(fixedKey)] && siteGroupData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleSiteGroup.inSet(fixedKey, siteGroupData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGroups = this.groups.filter(i => i.isListening === true);
        visibleGroups.forEach(function (visibleGroup) {
            return __awaiter(this, void 0, void 0, function* () {
                let groupData = yield self.apiService.getGroup({ id: visibleGroup.id });
                Object.keys(visibleGroup).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGroup[fixedKey] !== groupData[(0, util_1.toSnake)(fixedKey)] && groupData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGroup.inSet(fixedKey, groupData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleTariffs = this.tariffs.filter(i => i.isListening === true);
        visibleTariffs.forEach(function (visibleTariff) {
            return __awaiter(this, void 0, void 0, function* () {
                let tariffData = yield self.apiService.getTariff({ id: visibleTariff.id });
                Object.keys(visibleTariff).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleTariff[fixedKey] !== tariffData[(0, util_1.toSnake)(fixedKey)] && tariffData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleTariff.inSet(fixedKey, tariffData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleReports = this.reports.filter(i => i.isListening === true);
        visibleReports.forEach(function (visibleReport) {
            return __awaiter(this, void 0, void 0, function* () {
                let reportData = yield self.apiService.getReport({ id: visibleReport.id });
                Object.keys(visibleReport).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleReport[fixedKey] !== reportData[(0, util_1.toSnake)(fixedKey)] && reportData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleReport.inSet(fixedKey, reportData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGaiaConversations = this.gaiaConversations.filter(i => i.isListening === true);
        visibleGaiaConversations.forEach(function (visibleGaiaConversation) {
            return __awaiter(this, void 0, void 0, function* () {
                let gaiaConversationData = yield self.apiService.getGaiaConversation({ id: visibleGaiaConversation.id });
                Object.keys(visibleGaiaConversation).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGaiaConversation[fixedKey] !== gaiaConversationData[(0, util_1.toSnake)(fixedKey)] && gaiaConversationData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGaiaConversation.inSet(fixedKey, gaiaConversationData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDataCategorys = this.dataCategorys.filter(i => i.isListening === true);
        visibleDataCategorys.forEach(function (visibleDataCategory) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataCategoryData = yield self.apiService.getDataCategory({ id: visibleDataCategory.id });
                Object.keys(visibleDataCategory).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDataCategory[fixedKey] !== dataCategoryData[(0, util_1.toSnake)(fixedKey)] && dataCategoryData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDataCategory.inSet(fixedKey, dataCategoryData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDataTypes = this.dataTypes.filter(i => i.isListening === true);
        visibleDataTypes.forEach(function (visibleDataType) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataTypeData = yield self.apiService.getDataType({ id: visibleDataType.id });
                Object.keys(visibleDataType).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDataType[fixedKey] !== dataTypeData[(0, util_1.toSnake)(fixedKey)] && dataTypeData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDataType.inSet(fixedKey, dataTypeData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleWidgetBoards = this.widgetBoards.filter(i => i.isListening === true);
        visibleWidgetBoards.forEach(function (visibleWidgetBoard) {
            return __awaiter(this, void 0, void 0, function* () {
                let widgetBoardData = yield self.apiService.getWidgetBoard({ id: visibleWidgetBoard.id });
                Object.keys(visibleWidgetBoard).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleWidgetBoard[fixedKey] !== widgetBoardData[(0, util_1.toSnake)(fixedKey)] && widgetBoardData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleWidgetBoard.inSet(fixedKey, widgetBoardData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAudits = this.audits.filter(i => i.isListening === true);
        visibleAudits.forEach(function (visibleAudit) {
            return __awaiter(this, void 0, void 0, function* () {
                let auditData = yield self.apiService.getAudit({ id: visibleAudit.id });
                Object.keys(visibleAudit).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAudit[fixedKey] !== auditData[(0, util_1.toSnake)(fixedKey)] && auditData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAudit.inSet(fixedKey, auditData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleApplications = this.applications.filter(i => i.isListening === true);
        visibleApplications.forEach(function (visibleApplication) {
            return __awaiter(this, void 0, void 0, function* () {
                let applicationData = yield self.apiService.getApplication({ id: visibleApplication.id });
                Object.keys(visibleApplication).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleApplication[fixedKey] !== applicationData[(0, util_1.toSnake)(fixedKey)] && applicationData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleApplication.inSet(fixedKey, applicationData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAnomalyModels = this.anomalyModels.filter(i => i.isListening === true);
        visibleAnomalyModels.forEach(function (visibleAnomalyModel) {
            return __awaiter(this, void 0, void 0, function* () {
                let anomalyModelData = yield self.apiService.getAnomalyModel({ id: visibleAnomalyModel.id });
                Object.keys(visibleAnomalyModel).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAnomalyModel[fixedKey] !== anomalyModelData[(0, util_1.toSnake)(fixedKey)] && anomalyModelData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAnomalyModel.inSet(fixedKey, anomalyModelData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAnomalys = this.anomalys.filter(i => i.isListening === true);
        visibleAnomalys.forEach(function (visibleAnomaly) {
            return __awaiter(this, void 0, void 0, function* () {
                let anomalyData = yield self.apiService.getAnomaly({ id: visibleAnomaly.id });
                Object.keys(visibleAnomaly).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAnomaly[fixedKey] !== anomalyData[(0, util_1.toSnake)(fixedKey)] && anomalyData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAnomaly.inSet(fixedKey, anomalyData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAccounts = this.accounts.filter(i => i.isListening === true);
        visibleAccounts.forEach(function (visibleAccount) {
            return __awaiter(this, void 0, void 0, function* () {
                let accountData = yield self.apiService.getAccount({ id: visibleAccount.id });
                Object.keys(visibleAccount).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAccount[fixedKey] !== accountData[(0, util_1.toSnake)(fixedKey)] && accountData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAccount.inSet(fixedKey, accountData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visiblePreferencess = this.preferencess.filter(i => i.isListening === true);
        visiblePreferencess.forEach(function (visiblePreferences) {
            return __awaiter(this, void 0, void 0, function* () {
                let preferencesData = yield self.apiService.getPreferences({ id: visiblePreferences.id });
                Object.keys(visiblePreferences).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visiblePreferences[fixedKey] !== preferencesData[(0, util_1.toSnake)(fixedKey)] && preferencesData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visiblePreferences.inSet(fixedKey, preferencesData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visiblePhysicalGateways = this.physicalGateways.filter(i => i.isListening === true);
        visiblePhysicalGateways.forEach(function (visiblePhysicalGateway) {
            return __awaiter(this, void 0, void 0, function* () {
                let physicalGatewayData = yield self.apiService.getPhysicalGateway({ id: visiblePhysicalGateway.id });
                Object.keys(visiblePhysicalGateway).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visiblePhysicalGateway[fixedKey] !== physicalGatewayData[(0, util_1.toSnake)(fixedKey)] && physicalGatewayData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visiblePhysicalGateway.inSet(fixedKey, physicalGatewayData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDataUploads = this.dataUploads.filter(i => i.isListening === true);
        visibleDataUploads.forEach(function (visibleDataUpload) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataUploadData = yield self.apiService.getDataUpload({ id: visibleDataUpload.id });
                Object.keys(visibleDataUpload).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDataUpload[fixedKey] !== dataUploadData[(0, util_1.toSnake)(fixedKey)] && dataUploadData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDataUpload.inSet(fixedKey, dataUploadData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleVerifyOrgInvites = this.verifyOrgInvites.filter(i => i.isListening === true);
        visibleVerifyOrgInvites.forEach(function (visibleVerifyOrgInvite) {
            return __awaiter(this, void 0, void 0, function* () {
                let verifyOrgInviteData = yield self.apiService.getVerifyOrgInvite({ id: visibleVerifyOrgInvite.id });
                Object.keys(visibleVerifyOrgInvite).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleVerifyOrgInvite[fixedKey] !== verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)] && verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleVerifyOrgInvite.inSet(fixedKey, verifyOrgInviteData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDcSessions = this.dcSessions.filter(i => i.isListening === true);
        visibleDcSessions.forEach(function (visibleDcSession) {
            return __awaiter(this, void 0, void 0, function* () {
                let dcSessionData = yield self.apiService.getDcSession({ id: visibleDcSession.id });
                Object.keys(visibleDcSession).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDcSession[fixedKey] !== dcSessionData[(0, util_1.toSnake)(fixedKey)] && dcSessionData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDcSession.inSet(fixedKey, dcSessionData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDcChargePoints = this.dcChargePoints.filter(i => i.isListening === true);
        visibleDcChargePoints.forEach(function (visibleDcChargePoint) {
            return __awaiter(this, void 0, void 0, function* () {
                let dcChargePointData = yield self.apiService.getDcChargePoint({ id: visibleDcChargePoint.id });
                Object.keys(visibleDcChargePoint).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDcChargePoint[fixedKey] !== dcChargePointData[(0, util_1.toSnake)(fixedKey)] && dcChargePointData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDcChargePoint.inSet(fixedKey, dcChargePointData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleResetTokens = this.resetTokens.filter(i => i.isListening === true);
        visibleResetTokens.forEach(function (visibleResetToken) {
            return __awaiter(this, void 0, void 0, function* () {
                let resetTokenData = yield self.apiService.getResetToken({ id: visibleResetToken.id });
                Object.keys(visibleResetToken).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleResetToken[fixedKey] !== resetTokenData[(0, util_1.toSnake)(fixedKey)] && resetTokenData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleResetToken.inSet(fixedKey, resetTokenData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleOrgPartners = this.orgPartners.filter(i => i.isListening === true);
        visibleOrgPartners.forEach(function (visibleOrgPartner) {
            return __awaiter(this, void 0, void 0, function* () {
                let orgPartnerData = yield self.apiService.getOrgPartner({ id: visibleOrgPartner.id });
                Object.keys(visibleOrgPartner).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleOrgPartner[fixedKey] !== orgPartnerData[(0, util_1.toSnake)(fixedKey)] && orgPartnerData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleOrgPartner.inSet(fixedKey, orgPartnerData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleOrganisationManagements = this.organisationManagements.filter(i => i.isListening === true);
        visibleOrganisationManagements.forEach(function (visibleOrganisationManagement) {
            return __awaiter(this, void 0, void 0, function* () {
                let organisationManagementData = yield self.apiService.getOrganisationManagement({ id: visibleOrganisationManagement.id });
                Object.keys(visibleOrganisationManagement).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleOrganisationManagement[fixedKey] !== organisationManagementData[(0, util_1.toSnake)(fixedKey)] && organisationManagementData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleOrganisationManagement.inSet(fixedKey, organisationManagementData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleStagingDatabases = this.stagingDatabases.filter(i => i.isListening === true);
        visibleStagingDatabases.forEach(function (visibleStagingDatabase) {
            return __awaiter(this, void 0, void 0, function* () {
                let stagingDatabaseData = yield self.apiService.getStagingDatabase({ id: visibleStagingDatabase.id });
                Object.keys(visibleStagingDatabase).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleStagingDatabase[fixedKey] !== stagingDatabaseData[(0, util_1.toSnake)(fixedKey)] && stagingDatabaseData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleStagingDatabase.inSet(fixedKey, stagingDatabaseData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleZigbeeFirmwares = this.zigbeeFirmwares.filter(i => i.isListening === true);
        visibleZigbeeFirmwares.forEach(function (visibleZigbeeFirmware) {
            return __awaiter(this, void 0, void 0, function* () {
                let zigbeeFirmwareData = yield self.apiService.getZigbeeFirmware({ id: visibleZigbeeFirmware.id });
                Object.keys(visibleZigbeeFirmware).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleZigbeeFirmware[fixedKey] !== zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)] && zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleZigbeeFirmware.inSet(fixedKey, zigbeeFirmwareData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGatewayTrustLists = this.gatewayTrustLists.filter(i => i.isListening === true);
        visibleGatewayTrustLists.forEach(function (visibleGatewayTrustList) {
            return __awaiter(this, void 0, void 0, function* () {
                let gatewayTrustListData = yield self.apiService.getGatewayTrustList({ id: visibleGatewayTrustList.id });
                Object.keys(visibleGatewayTrustList).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGatewayTrustList[fixedKey] !== gatewayTrustListData[(0, util_1.toSnake)(fixedKey)] && gatewayTrustListData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGatewayTrustList.inSet(fixedKey, gatewayTrustListData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGatewayTrustedDeviceAnalysiss = this.gatewayTrustedDeviceAnalysiss.filter(i => i.isListening === true);
        visibleGatewayTrustedDeviceAnalysiss.forEach(function (visibleGatewayTrustedDeviceAnalysis) {
            return __awaiter(this, void 0, void 0, function* () {
                let gatewayTrustedDeviceAnalysisData = yield self.apiService.getGatewayTrustedDeviceAnalysis({ id: visibleGatewayTrustedDeviceAnalysis.id });
                Object.keys(visibleGatewayTrustedDeviceAnalysis).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGatewayTrustedDeviceAnalysis[fixedKey] !== gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)] && gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGatewayTrustedDeviceAnalysis.inSet(fixedKey, gatewayTrustedDeviceAnalysisData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAggregateTelemetrys = this.aggregateTelemetrys.filter(i => i.isListening === true);
        visibleAggregateTelemetrys.forEach(function (visibleAggregateTelemetry) {
            return __awaiter(this, void 0, void 0, function* () {
                let aggregateTelemetryData = yield self.apiService.getAggregateTelemetry({ id: visibleAggregateTelemetry.id });
                Object.keys(visibleAggregateTelemetry).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAggregateTelemetry[fixedKey] !== aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)] && aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAggregateTelemetry.inSet(fixedKey, aggregateTelemetryData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleInstantaneousTelemetrys = this.instantaneousTelemetrys.filter(i => i.isListening === true);
        visibleInstantaneousTelemetrys.forEach(function (visibleInstantaneousTelemetry) {
            return __awaiter(this, void 0, void 0, function* () {
                let instantaneousTelemetryData = yield self.apiService.getInstantaneousTelemetry({ id: visibleInstantaneousTelemetry.id });
                Object.keys(visibleInstantaneousTelemetry).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleInstantaneousTelemetry[fixedKey] !== instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)] && instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleInstantaneousTelemetry.inSet(fixedKey, instantaneousTelemetryData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleGatewayGods = this.gatewayGods.filter(i => i.isListening === true);
        visibleGatewayGods.forEach(function (visibleGatewayGod) {
            return __awaiter(this, void 0, void 0, function* () {
                let gatewayGodData = yield self.apiService.getGatewayGod({ id: visibleGatewayGod.id });
                Object.keys(visibleGatewayGod).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleGatewayGod[fixedKey] !== gatewayGodData[(0, util_1.toSnake)(fixedKey)] && gatewayGodData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleGatewayGod.inSet(fixedKey, gatewayGodData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleAssetGods = this.assetGods.filter(i => i.isListening === true);
        visibleAssetGods.forEach(function (visibleAssetGod) {
            return __awaiter(this, void 0, void 0, function* () {
                let assetGodData = yield self.apiService.getAssetGod({ id: visibleAssetGod.id });
                Object.keys(visibleAssetGod).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleAssetGod[fixedKey] !== assetGodData[(0, util_1.toSnake)(fixedKey)] && assetGodData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleAssetGod.inSet(fixedKey, assetGodData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleDataUnits = this.dataUnits.filter(i => i.isListening === true);
        visibleDataUnits.forEach(function (visibleDataUnit) {
            return __awaiter(this, void 0, void 0, function* () {
                let dataUnitData = yield self.apiService.getDataUnit({ id: visibleDataUnit.id });
                Object.keys(visibleDataUnit).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleDataUnit[fixedKey] !== dataUnitData[(0, util_1.toSnake)(fixedKey)] && dataUnitData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleDataUnit.inSet(fixedKey, dataUnitData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
        let visibleItemMetadatas = this.itemMetadatas.filter(i => i.isListening === true);
        visibleItemMetadatas.forEach(function (visibleItemMetadata) {
            return __awaiter(this, void 0, void 0, function* () {
                let itemMetadataData = yield self.apiService.getItemMetadata({ id: visibleItemMetadata.id });
                Object.keys(visibleItemMetadata).forEach(function (key) {
                    let fixedKey = key.substr(1);
                    if (visibleItemMetadata[fixedKey] !== itemMetadataData[(0, util_1.toSnake)(fixedKey)] && itemMetadataData[(0, util_1.toSnake)(fixedKey)] !== undefined) {
                        visibleItemMetadata.inSet(fixedKey, itemMetadataData[(0, util_1.toSnake)(fixedKey)]);
                    }
                });
            });
        });
    }
    getVisibleObjects() {
        let visibleObjectList = [];
        visibleObjectList.push({ type: 'list', list: this.lists.filter(i => i.isListening === true).map(i => i.requestIds.map(rId => ({ id: rId, type: i.type }))).flat() });
        visibleObjectList.push({ type: 'asset', list: this.assets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gateway', list: this.gateways.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewaySoftwareVersion', list: this.gatewaySoftwareVersions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'site', list: this.sites.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'order', list: this.orders.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'session', list: this.sessions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'discount', list: this.discounts.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'stripeSession', list: this.stripeSessions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'stripeWebhook', list: this.stripeWebhooks.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'zapierWebhook', list: this.zapierWebhooks.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'places', list: this.placess.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'product', list: this.products.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'modbusModel', list: this.modbusModels.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'occupancySchedule', list: this.occupancySchedules.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'pubOrg', list: this.pubOrgs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'organisation', list: this.organisations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'paymentCard', list: this.paymentCards.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetEvent', list: this.assetEvents.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayEvent', list: this.gatewayEvents.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetTelemetry', list: this.assetTelemetrys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'rule', list: this.rules.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataRequest', list: this.dataRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataRequestLink', list: this.dataRequestLinks.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'invoiceRequest', list: this.invoiceRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'invoiceRequestLink', list: this.invoiceRequestLinks.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'siteGroup', list: this.siteGroups.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'group', list: this.groups.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'duckChargeAdmin', list: this.duckChargeAdmins.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'customFieldType', list: this.customFieldTypes.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'customField', list: this.customFields.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'location', list: this.locations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'searchHistory', list: this.searchHistorys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'tariff', list: this.tariffs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'groupType', list: this.groupTypes.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'calculatorInbound', list: this.calculatorInbounds.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'calculatorResult', list: this.calculatorResults.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'createReport', list: this.createReports.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'reportHistory', list: this.reportHistorys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'report', list: this.reports.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'reportFile', list: this.reportFiles.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gaiaConversation', list: this.gaiaConversations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gaiaMessage', list: this.gaiaMessages.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataCategory', list: this.dataCategorys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataType', list: this.dataTypes.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'deviceCategory', list: this.deviceCategorys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'widgetBoard', list: this.widgetBoards.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'reportFileLink', list: this.reportFileLinks.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'ruleEvent', list: this.ruleEvents.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'audit', list: this.audits.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'application', list: this.applications.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'anomalyModel', list: this.anomalyModels.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'anomaly', list: this.anomalys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gridduckSubscription', list: this.gridduckSubscriptions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gridduckInvoice', list: this.gridduckInvoices.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'account', list: this.accounts.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'customFieldData', list: this.customFieldDatas.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'preferences', list: this.preferencess.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dcRetryPayment', list: this.dcRetryPayments.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'issue', list: this.issues.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'ignoredDevice', list: this.ignoredDevices.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'resetSecret', list: this.resetSecrets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'requestSecret', list: this.requestSecrets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetIdentification', list: this.assetIdentifications.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'getPhaseBreakdown', list: this.getPhaseBreakdowns.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'availableGateway', list: this.availableGateways.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetDemand', list: this.assetDemands.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetConsumption', list: this.assetConsumptions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'physicalGateway', list: this.physicalGateways.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'sitePermission', list: this.sitePermissions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'applianceCategory', list: this.applianceCategorys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'applianceType', list: this.applianceTypes.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataUpload', list: this.dataUploads.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'file', list: this.files.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'zip', list: this.zips.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'search', list: this.searchs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'verifyOrgInvite', list: this.verifyOrgInvites.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'confirmOrgInvite', list: this.confirmOrgInvites.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dcCreateAccount', list: this.dcCreateAccounts.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dcSession', list: this.dcSessions.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'paymentSheet', list: this.paymentSheets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dcChargePoint', list: this.dcChargePoints.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dcChargeStation', list: this.dcChargeStations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'organisationInvite', list: this.organisationInvites.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'organisationMember', list: this.organisationMembers.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'detectedDevice', list: this.detectedDevices.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'resetToken', list: this.resetTokens.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'password', list: this.passwords.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'thirdPartyIntegration', list: this.thirdPartyIntegrations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'orgPartner', list: this.orgPartners.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'mfaSecret', list: this.mfaSecrets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'mfaVerification', list: this.mfaVerifications.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'mfaAuthentication', list: this.mfaAuthentications.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'loginAs', list: this.loginAss.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'loginAsPartner', list: this.loginAsPartners.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'organisationManagement', list: this.organisationManagements.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'stagingDatabase', list: this.stagingDatabases.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'notification', list: this.notifications.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'zigbeeFirmware', list: this.zigbeeFirmwares.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayTrustList', list: this.gatewayTrustLists.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayTrustedDeviceUntrustRequest', list: this.gatewayTrustedDeviceUntrustRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'telemetryOperation', list: this.telemetryOperations.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'aggregateTelemetryGroupRequest', list: this.aggregateTelemetryGroupRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetRemoveDataRequest', list: this.assetRemoveDataRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetAggregateDataRequest', list: this.assetAggregateDataRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayTrustedDeviceAnalysis', list: this.gatewayTrustedDeviceAnalysiss.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'aggregateTelemetry', list: this.aggregateTelemetrys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'instantaneousTelemetry', list: this.instantaneousTelemetrys.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'organisationSearch', list: this.organisationSearchs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayLogDownloadRequest', list: this.gatewayLogDownloadRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayEnhancedLogDownloadRequest', list: this.gatewayEnhancedLogDownloadRequests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'gatewayGod', list: this.gatewayGods.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetGod', list: this.assetGods.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetTelemetryBatch', list: this.assetTelemetryBatchs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetConsumptionBatch', list: this.assetConsumptionBatchs.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'rawAggregateData', list: this.rawAggregateDatas.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'assetReset', list: this.assetResets.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'energyMasterTest', list: this.energyMasterTests.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'inspiredLogin', list: this.inspiredLogins.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'dataUnit', list: this.dataUnits.filter(i => i.isListening === true).map(i => i.id) });
        visibleObjectList.push({ type: 'itemMetadata', list: this.itemMetadatas.filter(i => i.isListening === true).map(i => i.id) });
        return visibleObjectList;
    }
    constructor(apiService, emitter) {
        super(apiService);
        this.assets = [];
        this.assetGetters = {};
        this.gateways = [];
        this.gatewayGetters = {};
        this.gatewaySoftwareVersions = [];
        this.gatewaySoftwareVersionGetters = {};
        this.sites = [];
        this.siteGetters = {};
        this.orders = [];
        this.orderGetters = {};
        this.sessions = [];
        this.sessionGetters = {};
        this.discounts = [];
        this.discountGetters = {};
        this.stripeSessions = [];
        this.stripeSessionGetters = {};
        this.stripeWebhooks = [];
        this.stripeWebhookGetters = {};
        this.zapierWebhooks = [];
        this.zapierWebhookGetters = {};
        this.placess = [];
        this.placesGetters = {};
        this.products = [];
        this.productGetters = {};
        this.modbusModels = [];
        this.modbusModelGetters = {};
        this.occupancySchedules = [];
        this.occupancyScheduleGetters = {};
        this.pubOrgs = [];
        this.pubOrgGetters = {};
        this.organisations = [];
        this.organisationGetters = {};
        this.paymentCards = [];
        this.paymentCardGetters = {};
        this.assetEvents = [];
        this.assetEventGetters = {};
        this.gatewayEvents = [];
        this.gatewayEventGetters = {};
        this.assetTelemetrys = [];
        this.assetTelemetryGetters = {};
        this.rules = [];
        this.ruleGetters = {};
        this.dataRequests = [];
        this.dataRequestGetters = {};
        this.dataRequestLinks = [];
        this.dataRequestLinkGetters = {};
        this.invoiceRequests = [];
        this.invoiceRequestGetters = {};
        this.invoiceRequestLinks = [];
        this.invoiceRequestLinkGetters = {};
        this.siteGroups = [];
        this.siteGroupGetters = {};
        this.groups = [];
        this.groupGetters = {};
        this.duckChargeAdmins = [];
        this.duckChargeAdminGetters = {};
        this.customFieldTypes = [];
        this.customFieldTypeGetters = {};
        this.customFields = [];
        this.customFieldGetters = {};
        this.locations = [];
        this.locationGetters = {};
        this.searchHistorys = [];
        this.searchHistoryGetters = {};
        this.tariffs = [];
        this.tariffGetters = {};
        this.groupTypes = [];
        this.groupTypeGetters = {};
        this.calculatorInbounds = [];
        this.calculatorInboundGetters = {};
        this.calculatorResults = [];
        this.calculatorResultGetters = {};
        this.createReports = [];
        this.createReportGetters = {};
        this.reportHistorys = [];
        this.reportHistoryGetters = {};
        this.reports = [];
        this.reportGetters = {};
        this.reportFiles = [];
        this.reportFileGetters = {};
        this.gaiaConversations = [];
        this.gaiaConversationGetters = {};
        this.gaiaMessages = [];
        this.gaiaMessageGetters = {};
        this.dataCategorys = [];
        this.dataCategoryGetters = {};
        this.dataTypes = [];
        this.dataTypeGetters = {};
        this.deviceCategorys = [];
        this.deviceCategoryGetters = {};
        this.widgetBoards = [];
        this.widgetBoardGetters = {};
        this.reportFileLinks = [];
        this.reportFileLinkGetters = {};
        this.ruleEvents = [];
        this.ruleEventGetters = {};
        this.audits = [];
        this.auditGetters = {};
        this.applications = [];
        this.applicationGetters = {};
        this.anomalyModels = [];
        this.anomalyModelGetters = {};
        this.anomalys = [];
        this.anomalyGetters = {};
        this.gridduckSubscriptions = [];
        this.gridduckSubscriptionGetters = {};
        this.gridduckInvoices = [];
        this.gridduckInvoiceGetters = {};
        this.accounts = [];
        this.accountGetters = {};
        this.customFieldDatas = [];
        this.customFieldDataGetters = {};
        this.preferencess = [];
        this.preferencesGetters = {};
        this.dcRetryPayments = [];
        this.dcRetryPaymentGetters = {};
        this.issues = [];
        this.issueGetters = {};
        this.ignoredDevices = [];
        this.ignoredDeviceGetters = {};
        this.resetSecrets = [];
        this.resetSecretGetters = {};
        this.requestSecrets = [];
        this.requestSecretGetters = {};
        this.assetIdentifications = [];
        this.assetIdentificationGetters = {};
        this.getPhaseBreakdowns = [];
        this.getPhaseBreakdownGetters = {};
        this.availableGateways = [];
        this.availableGatewayGetters = {};
        this.assetDemands = [];
        this.assetDemandGetters = {};
        this.assetConsumptions = [];
        this.assetConsumptionGetters = {};
        this.physicalGateways = [];
        this.physicalGatewayGetters = {};
        this.sitePermissions = [];
        this.sitePermissionGetters = {};
        this.applianceCategorys = [];
        this.applianceCategoryGetters = {};
        this.applianceTypes = [];
        this.applianceTypeGetters = {};
        this.dataUploads = [];
        this.dataUploadGetters = {};
        this.files = [];
        this.fileGetters = {};
        this.zips = [];
        this.zipGetters = {};
        this.searchs = [];
        this.searchGetters = {};
        this.verifyOrgInvites = [];
        this.verifyOrgInviteGetters = {};
        this.confirmOrgInvites = [];
        this.confirmOrgInviteGetters = {};
        this.dcCreateAccounts = [];
        this.dcCreateAccountGetters = {};
        this.dcSessions = [];
        this.dcSessionGetters = {};
        this.paymentSheets = [];
        this.paymentSheetGetters = {};
        this.dcChargePoints = [];
        this.dcChargePointGetters = {};
        this.dcChargeStations = [];
        this.dcChargeStationGetters = {};
        this.organisationInvites = [];
        this.organisationInviteGetters = {};
        this.organisationMembers = [];
        this.organisationMemberGetters = {};
        this.detectedDevices = [];
        this.detectedDeviceGetters = {};
        this.resetTokens = [];
        this.resetTokenGetters = {};
        this.passwords = [];
        this.passwordGetters = {};
        this.thirdPartyIntegrations = [];
        this.thirdPartyIntegrationGetters = {};
        this.orgPartners = [];
        this.orgPartnerGetters = {};
        this.mfaSecrets = [];
        this.mfaSecretGetters = {};
        this.mfaVerifications = [];
        this.mfaVerificationGetters = {};
        this.mfaAuthentications = [];
        this.mfaAuthenticationGetters = {};
        this.loginAss = [];
        this.loginAsGetters = {};
        this.loginAsPartners = [];
        this.loginAsPartnerGetters = {};
        this.organisationManagements = [];
        this.organisationManagementGetters = {};
        this.stagingDatabases = [];
        this.stagingDatabaseGetters = {};
        this.notifications = [];
        this.notificationGetters = {};
        this.zigbeeFirmwares = [];
        this.zigbeeFirmwareGetters = {};
        this.gatewayTrustLists = [];
        this.gatewayTrustListGetters = {};
        this.gatewayTrustedDeviceUntrustRequests = [];
        this.gatewayTrustedDeviceUntrustRequestGetters = {};
        this.telemetryOperations = [];
        this.telemetryOperationGetters = {};
        this.aggregateTelemetryGroupRequests = [];
        this.aggregateTelemetryGroupRequestGetters = {};
        this.assetRemoveDataRequests = [];
        this.assetRemoveDataRequestGetters = {};
        this.assetAggregateDataRequests = [];
        this.assetAggregateDataRequestGetters = {};
        this.gatewayTrustedDeviceAnalysiss = [];
        this.gatewayTrustedDeviceAnalysisGetters = {};
        this.aggregateTelemetrys = [];
        this.aggregateTelemetryGetters = {};
        this.instantaneousTelemetrys = [];
        this.instantaneousTelemetryGetters = {};
        this.organisationSearchs = [];
        this.organisationSearchGetters = {};
        this.gatewayLogDownloadRequests = [];
        this.gatewayLogDownloadRequestGetters = {};
        this.gatewayEnhancedLogDownloadRequests = [];
        this.gatewayEnhancedLogDownloadRequestGetters = {};
        this.gatewayGods = [];
        this.gatewayGodGetters = {};
        this.assetGods = [];
        this.assetGodGetters = {};
        this.assetTelemetryBatchs = [];
        this.assetTelemetryBatchGetters = {};
        this.assetConsumptionBatchs = [];
        this.assetConsumptionBatchGetters = {};
        this.rawAggregateDatas = [];
        this.rawAggregateDataGetters = {};
        this.assetResets = [];
        this.assetResetGetters = {};
        this.energyMasterTests = [];
        this.energyMasterTestGetters = {};
        this.inspiredLogins = [];
        this.inspiredLoginGetters = {};
        this.dataUnits = [];
        this.dataUnitGetters = {};
        this.itemMetadatas = [];
        this.itemMetadataGetters = {};
        this.emitter = emitter;
        let self = this;
        this.apiService.onLoggedIn(this.clearLists.bind(this));
        this.apiService.onOpenConnectionCallback(this.resync.bind(this));
    }
}
exports.default = DataService;
//# sourceMappingURL=data-service.js.map